import { LOCALES } from '../../utils/i18n/constants'

export default {
  [LOCALES.GERMAN]: {
    't_aas': 'Alle Gebiete',
    't_parent_fund': '(DE Parent fund)',
    't_account_locked': 'Account gesperrt',
    't_action': 'Aktion',
    't_action_error_message': 'Bitte korrigieren Sie die rot markierten Probleme',
    't_action_excel': 'SIERA Aktionsplan.xlsx',
    't_action_pdf': 'SIERA Aktionsplan.pdf',
    't_action_plan': 'Aktionsplan',
    't_action_completion_dates': 'Die Termine für den Abschluss der Aktion nähern sich',
    't_actions': 'Aktionen',
    't_actions_under_review': 'Geprüfte Maßnahmen',
    't_actual': 'Tatsächlich',
    't_grey': 'Nicht abgedeckt',
    't_add_action': 'Aktion hinzufügen',
    't_add_an_action': 'Eine Aktion hinzufügen',
    't_no_action_data': 'Es sind keine Aktionen zum Anzeigen vorhanden',
    't_add_action_title': 'Aktionstitel hinzufügen',
    't_add_date': 'Datum hinzufügen',
    't_add_note': 'Fügen Sie eine Notiz hinzu',
    't_add_note_description': 'Fügen Sie eine Notiz hinzu, um diese Abweichung des Energieverbrauchs von den vereinbarten Zielen zu erklären.',
    't_agreed': 'Einverstanden',
    't_agreed_actions': 'Vereinbarte Maßnahmen',
    't_asset_agree_actions': 'DE Agreed actions',
    't_Asset_EPC_rating': 'DE EPC ratings',
    't_all': 'Alles',
    't_all_actions': 'Alle Aktionen',
    't_alu': 'Alle Versorgungsunternehmen',
    't_api_email_error': 'Benutzer-E-Mail nicht gefunden',
    't_applicable': 'Anwendbar',
    't_applicable_actions': 'Anwendbare Aktionen',
    't_approved': 'Freigegeben',
    't_apr': 'Apr',
    't_april': 'April',
    't_assets_missing_performance_targets': 'Assets verfehlen ihre Leistungsziele',
    't_asset_summary': 'Asset Zusammenfassung',
    't_assets': 'DE Asset',
    't_asset_s': 'DE Assets',
    't_aug': 'Aug',
    't_august': 'August',
    't_back_sign_in': 'Zurück zu Anmelden',
    't_biodiversity': 'Biodiversität',
    't_break': 'unterbrechen',
    't_email_hint': 'DE Recipients (separate multiple email addresses with commas)',
    't_btn_enter': 'Daten eingeben',
    't_btn_request': 'Daten abfragen',
    't_building_manager': 'Gebäudemanager',
    't_building_performance': 'Gebäudeleistung',
    't_cancel': 'Stornieren',
    't_capital_non_recover': 'Kapital - Nicht weiterbelastbar',
    't_capital_recover': 'Kapital - weiterbelastbar',
    't_carbon': 'Kohlenstoff',
    't_cbx_label_all': 'Alles auswählen',
    't_certifications': 'Zertifizierungen',
    't_certificates': 'DE Certificates',
    't_change': 'Ändern',
    't_change_password': 'Passwort ändern',
    't_check_all_completed': 'Alle als abgeschlossen markieren',
    't_close_without_save': 'Schließen ohne speichern?',
    't_commercial_event': 'Kommerzielle Ereigniss',
    't_commercial_events': 'Kommerzielle Ereignisse',
    't_commonareas': 'Gemeinschaftsbereiche',
    't_community_engagement': 'Engagement für die Gemeinschaft',
    't_complete_by': 'Abzuschließen bis',
    't_complete': 'Komplett',
    't_completed': 'Abgeschlossen',
    't_completed_actions': 'Abgeschlossene Vorgänge',
    't_completion': 'Fertigstellung',
    't_completion_date': 'Fertigstellungstermin',
    't_confirm_new_password': 'Bestätigen Sie das neue Passwort',
    't_contact_evora': 'EVORA kontaktieren',
    't_contact_problem_msg_1': 'Problem, Zugang zu erhalten?',
    't_contact_problem_msg_2': 'Haben Sie Probleme?',
    't_contact_us': 'Kontaktieren Sie uns',
    't_content': 'Inhalt',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cost': 'Kosten',
    't_cost_type': 'Kostenart',
    't_create_password': 'Neues Passwort erstellen',
    't_current_password': 'Aktuelles Passwort',
    't_data': 'DE Data',
    't_no_records_found': 'DE No records found',
    't_dashboard': 'Dashboard',
    't_dashboard_pdf': 'SIERA Dashboard.pdf',
    't_data_quality': 'Datenqualität',
    't_data_quality_two_lines': 'Datenqualität',
    't_date': 'Datum',
    't_dec': 'Dez',
    't_december': 'Dezember',
    't_detail': 'Detail',
    't_district_cooling': 'Fernkälte',
    't_district_heating': 'Fernwärme',
    't_districtcooling': 'Fernkälte',
    't_districtheating': 'Fernwärme',
    't_dq_data_entered': 'Daten eingegeben',
    't_dq_data_provided_on': 'Zur Verfügung gestellt am',
    't_dq_data_requested': 'Daten angefordert',
    't_dq_data_requested_on': 'Angefordert am',
    't_due_date': 'Fällig am',
    't_edit': 'Bearbeiten',
    't_electricity': 'Elektrizität',
    't_email': 'Ihre E-Mail',
    't_email_reset': 'Bitte prüfen Sie Ihre E-Mail für Details zur Anmeldung.',
    't_email_notifications': 'E-Mail-Benachrichtigungen',
    't_energy': 'Energie',
    't_energyintensity': 'DE Energy Intensity',
    't_energy_rating': 'Energie-bewertung',
    't_EPC_rating': 'DE EPC rating',
    't_english': 'Englisch',
    't_enter_data': 'Daten eingeben',
    't_enter_current_password': 'Bitte geben Sie Ihr aktuelles Passwort ein',
    't_error': 'Sie können sich leider nicht anmelden',
    't_error_account_locked': 'Der Account ist aufgrund zu vieler Fehlversuche gesperrt.',
    't_error_account_revoked': 'Ein Administrator hat Ihren Zugriff auf dieses Konto widerrufen.',
    't_error_back_to_homepage': 'Gehen Sie zurück zur Startseite',
    't_error_try_msg': 'Versuchen Sie es in ein paar Stunden erneut.',
    't_error_user_password': 'Falsche E-Mail/Passwort, bitte versuchen Sie es erneut.',
    't_error_user_no_access': 'Falsche E-Mail/Passwort, bitte versuchen Sie es erneut.',
    't_esg_action_plan': 'Aktionsplan',
    't_esg_dashboard': 'Dashboard',
    't_esg_data_quality': 'Datenqualität',
    't_esg_passport': 'Pass',
    't_esg_performance': 'Leistung',
    't_portfolio_pdf' : 'DE SIERA Portfolio.pdf',
    't_date_range' : 'DE Date range',
    't_add_cost_estimate':'DE Add cost estimate',
    't_add_manager': 'DE Add manager',
    't_est': 'SCHÄTZUNG',
    't_estimated_overspend': 'geschätzte Mehrausgaben',
    't_event': 'Ereignis',
    't_events': 'Ereignisse',
    't_excel': 'Excel',
    't_expand_full_list': 'Vollständige Liste ausklappen',
    't_expiry': 'Ablauf',
    't_export': 'Export',
    't_exterior': 'Außen',
    't_feb': 'Feb',
    't_february': 'Februar',
    't_find_asset': 'Asset finden',
    't_floor_area': 'Bodenfläche',
    't_forgot_password': 'Passwort vergessen',
    't_french': 'Französisch',
    't_friday': 'Freitag',
    't_fund': 'Fonds',
    't_fund_reports': 'DE Reports',
    't_fund_report_content': 'DE Reports Content',
    't_gas': 'DE Gas',
    't_gasFuelsAndThermals': 'Gas, Brennstoffe & Wärme',
    't_gas_fuel_thermal': 'Gas, Brennstoffe & Wärme',
    't_gasfuelsandthermals': 'Gas, Brennstoffe & Wärme',
    't_german': 'Deutsch',
    't_go_back': 'Geh zurück',
    't_governance_recommendations': 'Governance-Empfehlungen',
    't_graph_landlord': 'Vermieter',
    't_tenant': 'Mieter',
    't_graph_ytd': 'Laufendes Jahr',
    't_gresb_measure': 'GRESB-bezogene Aktionen',
    't_health_and_wellbeing': 'Gesundheit & Wohlbefinden',
    't_heatmap_header': 'Zähler',
    't_heatmap_no_meterdata_msg': 'Keine Zählerdaten für ausgewählten Versorger und Bereich gefunden.',
    't_impact': 'Auswirkung',
    't_in_progress': 'In Bearbeitung',
    't_incorrect_current_password': 'Dieses Passwort ist falsch.',
    't_italian': 'Italienisch',
    't_invalid_token': 'Ungültiges Token.',
    't_jan': 'Jan',
    't_january': 'Januar',
    't_jpg': 'JPG-Grafiken',
    't_jul': 'Jul',
    't_july': 'Juli',
    't_jun': 'Jun',
    't_june': 'Juni',
    't_kg': 'kg',
    't_kWh': 'kWh',
    't_land_fill': 'Deponie',
    't_landfill': 'Deponie',
    't_landfill_remaining': 'Restdeponie',
    't_landlord': 'Vermieter',
    't_landlord_complete': 'Vermieter abgeschlossen',
    't_landlord_missing': 'Vermieter fehlt',
    't_language': 'Sprache',
    't_last_quarter': 'Letztes Quartal',
    't_last_refurb': 'Letzte Renovierung.',
    't_last_refurbished': 'Zuletzt überholt',
    't_latest': 'Neueste',
    't_location': 'Standort',
    't_logout': 'Abmelden',
    't_m': 'M',
    't_manager': 'Manager',
    't_mar': 'März',
    't_march': 'März',
    't_may': 'Mai',
    't_missing': 'UNVOLLSTÄNDIG',
    't_missing_tc': 'Fehlend',
    't_missing_lc': 'fehlend',
    't_missing_performance_data': 'Fehlende Leistungsdaten',
    't_missing_data': 'Fehlende Daten',
    't_missing_data_meter': 'Zähler',
    't_missing_data_reading': 'Ablesung',
    't_missing_data_type': 'Typ',
    't_monday': 'Montag',
    't_msg_empty_msg': 'Es gibt keine fehlenden Daten für diesen Zeitraum',
    't_msg_no_data': 'Keine Daten',
    't_msg_qtr_empty': 'Keine Datenlücken für den ausgewählten Zeitraum erfasst',
    't_nc': 'NICHT INKLUSIVE',
    't_not_covered_uc': 'DE NOT COVERED',
    't_new_password': 'Neues Kennwort',
    't_no': 'Nein',
    't_no_action_plan': 'Leider keine Daten gefunden.',
    't_no_completed_action': 'Für abgeschlossene Aktionen wurden leider keine Daten gefunden.',
    't_no_data_msg_1': 'Leider konnten wir mit {0} keine Ergebnisse finden. Versuchen Sie es mit einem anderen Suchbegriff.',
    't_no_data_msg_2': 'Es tut uns leid, wir konnten keine Ergebnisse finden.',
    't_no_events_found': 'Es tut uns leid, wir konnten keine Ereignis finden.',
    't_non_recycled': 'Nicht recycelt',
    't_none': 'Keine',
    't_non_rec': 'NICHT REC.',
    't_non_applicable': 'Unzutreffend',
    't_notes': 'Anmerkungen',
    't_notif_template_action': 'Die Aktion {0} ist in einem (1) Monat fällig. {1}',
    't_notif_template_action_link_1': 'Ein Update hinzufügen',
    't_notif_template_data_quality': '{0} Daten für Zähler: {1} fehlen. {2} or {3} Fordern Sie es von einem Kollegen an.',
    't_notif_template_data_quality_link_1': 'Fordern Sie die Daten an',
    't_notif_template_performance': 'Die {0}-Leistung für {1} liegt {2} {3} dem Ziel. {4}, um die Abweichung zu erklären.',
    't_notif_template_performance_link_1': 'Fügen Sie eine Notiz hinzu ',
    't_notifications': 'Benachrichtigungen',
    't_nov': 'Nov',
    't_november': 'November',
    't_occupancy': 'Belegung',
    't_oct': 'Okt',
    't_october': 'Oktober',
    't_oil': 'Öl',
    't_one_year': '1 Jahr',
    't_other': 'Andere',
    't_other_notifications': 'Wir benachrichtigen Sie auch, wenn: ',
    't_outdoorexteriorareaparking': 'Außenparkplatz im Freien',
    't_over': 'Über',
    't_est_overspend': 'geschätzte Ausgabenüberschreitung',
    't_passport': 'Reisepass',
    't_passport_pdf': 'SIERA Pass.pdf',
    't_password': 'Ihr Passwort',
    't_password_criteria': 'Passwort entspricht nicht den Anforderungen',
    't_password_mismatch': 'Passwörter stimmen nicht überein, bitte überprüfen',
    't_password_rules': 'Muss mindestens 10 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben, eine Ziffer und eine Sonderzeichen enthalten.',
    't_past_12_months': 'Letzte 12 Monate',
    't_pdf': 'Ganze Seite PDF',
    't_pdf_exported': 'PDF exportiert',
    't_pdf_page': 'Seite',
    't_pdf_pagination_copyright': '© Design und Layout dieses Berichts unterliegen dem Copyright von EVORA Global Ltd. Die in diesem Bericht enthaltenen Daten basieren ausschließlich auf den vom Kunden bereitgestellten Daten und gehören dem Kunden. EVORA Global Ltd. ist nicht für die Qualität oder Genauigkeit dieser Daten verantwortlich.',
    't_perf_pdf': 'SIERA Leistung.pdf',
    't_performance': 'Leistung',
    't_performance_commerial_event_template': '{0} Mietvertrag {1}',
    't_performance_completed_action_template': '{0} - abgeschlossen',
    't_performance_data_missing_event_template': '{0} fehlen Daten für {1}-Zähler',
    't_performance_event_template': 'Der {0}verbrauch für {1} liegt {2} {3} dem Ziel',
    't_performance_event_waste_template': 'Die {0}leistung für {1} liegt {2} {3} dem Ziel',
    't_performance_variance': 'Leistung',
    't_data_quality_issue': 'Datenqualität',
    't_pop_up_data_missing': 'Daten fehlen',
    't_portfolio_name': 'Portfolio',
    't_posted': 'Gesendet',
    't_privacy': 'Datenschutz',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: 3rd Floor, Birrane House, 2-4 Southwark Street, London, SE1 1TQ. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https://ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_quarterly_email_notification': 'Erhalten Sie vierteljährliche E-Mails, die Folgendes hervorheben: ',
    't_recycled': 'Recycelt',
    't_reduction': 'Reduktion',
    't_req_from': 'Von',
    't_req_hi': 'Hallo',
    't_red': 'Daten fehlen',
    't_req_meter': 'Zähler',
    't_req_missing_data_period': 'Fehlende/r Datenzeit/raum/räume',
    't_req_recipient': 'Empfänger',
    't_req_send': 'Senden',
    't_req_subject': 'Betreff',
    't_req_thanks': 'Danke',
    't_req_utility': 'Versorgungsunternehmen',
    't_request_data': 'Daten abfragen',
    't_req_supplier': 'DE Supplier (if known)',
    't_revenue_service': 'Umsatz - Nebenkosten',
    't_saturday': 'Samstag',
    't_save': 'Speichern',
    't_saving': 'geschätzte Einsparung',
    't_scope': 'Umfang',
    't_select': 'Wählen',
    't_send_reminder': 'Senden Sie eine Erinnerung',
    't_sep': 'Sep',
    't_september': 'September',
    't_set_dates': 'Termine einstellen',
    't_set_reminder_date': 'Erinnerungsdatum einstellen',
    't_settings': 'Einstellungen',
    't_sharedservices': 'Geteilte Dienstleistungen',
    't_show_more': 'Mehr anzeigen',
    't_sign_in': 'Anmelden',
    't_six_months': '6 Monate',
    't_social_value': 'Sozialen Wert',
    't_sort_by': 'Sortieren nach',
    't_spanish': 'Spanisch',
    't_status': 'Status',
    't_submit': 'Senden',
    't_sunday': 'Sonntag',
    't_swedish': 'Schwedisch',
    't_task': 'Aufgabe',
    't_template_qtr_label': '{0} {1} - {2} {3}',
    't_tenant_complete': 'Mieter abgeschlossen',
    't_tenant_missing': 'Mieter fehlt',
    't_tenant_engagement': 'Mietereinbindung',
    't_tenant_services': 'Mieterservice',
    't_tenantspace': 'Mietbereich',
    't_terms': 'Begriffe',
    't_this_quarter': 'Dieses Quartal',
    't_three_months': '3 Monate',
    't_thursday': 'Donnerstag',
    't_title_cannot_request_data': 'Daten können nicht angefordert werden',
    't_title_cannot_post_data': 'DE Add user failed',
    't_title_cannot_put_data': 'DE Update user failed',
    't_title_cannot_put_data_group':'DE Update group failed',
    't_title_cannot_post_data_group':'DE Add group failed',
    't_title_cannot_add_asset': 'DE Add asset failed',
    't_today': 'Heute',
    't_ton': 't',
    't_tonnes': 'Tonnen',
    't_total': 'Gesamt',
    't_total_recycling': 'Gesamtrecycling',
    't_try_again': 'Versuchen Sie es nochmal',
    't_tuesday': 'Dienstag',
    't_type': 'Typ',
    't_under': 'unter',
    't_under_review': 'Wird überprüft',
    't_under_target': 'Zielunterschreitung für Periode',
    't_util_cooling': 'Fernkälte',
    't_util_heating': 'Fernwärme',
    't_view_all': 'Alle anzeigen',
    't_waste': 'Abfall\n' +
        'Recycling',
    't_waste_title': 'Abfall {0} Recycling',
    't_waste_recycling': 'Abfall Recycling',
    'Waste': 'Abfall',
    't_water': 'Wasser',
    't_wednesday': 'Mittwoch',
    't_wellbeing': 'Wohlbefinden',
    't_wholebuilding': 'Gesamtes Gebäude',
    't_yes': 'Ja',
    't_yesterday': 'Gestern',
    't_y_o_y': 'Jahr nach Jahr',
    't_y_o_y_dialog_text': '<p><strong>Die Zielabweichung</strong> bezieht sich auf die Leistung einer Anlage in diesem Jahr bis heute, verglichen mit dem gleichen Zeitraum im letzten Jahr für einen bestimmten Nutzen, angezeigt als prozentuale Veränderung gegenüber dem Vorjahr. Wenn für einen Vermögenswert in SIERA ein Ziel für Versorgungszwecke festgelegt wurde, basiert dieser Prozentsatz auf dem Vorjahr.</p>',
    't_y_o_y_target': 'Jahr bis heute, Abweichung vom Ziel',
    't_ytd': 'Jahr bis heute, Abweichung vom Ziel',
    't_ytd_uppercase': 'LAUFENDES JAHR',
    't_show_targets': 'Ziele anzeigen',
    't_estimated': 'geschätzt',
    't_estimate': 'DE ESTIMATED',
    't_start_date': 'Startdatum',
    't_end_date': 'Endtermin',
    't_year': 'Jahr',
    't_reporting_year': 'DE Reporting Year',
    't_asset_values' : 'DE Asset Values',
    't_fossil_fuel_exposure' : 'DE Fossil Fuel Exposure',
    't_planning_permission_date' : 'DE Planning Permission Date',
    't_epc_coverage' : 'DE EPC Coverage',
    't_ped' : 'DE PED',
    't_nzeb_threshold' : 'DE NZEB Threshold',
    't_asset_floor_area' : 'DE Asset Floor Area',
    't_total_raw_materials_weight' : 'DE Total Raw Materials Weight',
    't_sustainable_raw_materials_weight' : 'DE Sustainable Raw Materials Weight',
    't_total_horizontal_area' : 'DE Total Horizontal Area',
    't_total_vertical_area' : 'DE Total Vertical Area',
    't_artificial_horizontal_area' : 'DE Artificial Horizontal Area',
    't_artificial_vertical_area' : 'DE Artificial Vertical Area',
    't_asset_values_extended': ' ',
    't_fossil_fuel_exposure_extended': 'DE An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_planning_permission_date_extended': 'DE  ',
    't_epc_coverage_extended': 'DE  ',
    't_nzeb_threshold_extended': 'DE A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'DE The gross internal area of the asset.',
    't_waste_management_extended': 'DE An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'DE The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'DE Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'DE This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'DE This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': 'DE “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': 'DE “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_missing_field_description': 'DE Missing Field Descriptions',
    't_picker_filter_value': '{0} Monate bis Ende {1} {2}',
    't_picker_filter_value_single_month': '{0} Monate bis Ende {1} {2}',
    't_variance_from_target' : 'Abweichung vom Ziel / Vorjahr',
    't_rank': 'Rang',
    't_under_recycling_target' : 'Under recycling target for period',
    't_over_recycling_target' : 'Over recycling target for period',
    't_est_savings': 'DE est. savings',
    't_add_note_dots': 'Fügen Sie eine Notiz hinzu...',
    't_done': 'Erledigt',
    't_password_reset_success': 'Ihr Passwort wurde zurückgesetzt',
    't_reset': 'Zurücksetzen',
    't_auto_meter_readings': 'Automatische Zählerablesung (Automatic Meter Readings, AMR)',
    't_auto_system_upgrades': 'Upgrade/Austausch von Automatisierungssystemen',
    't_composting_landscape': 'Kompostierung von Landschaftspflege- und/oder Lebensmittelabfällen',
    't_cooling_tower': 'Kühlturm',
    't_drip_irrigation': 'Tropf-/intelligente Bewässerung',
    't_drought_tolerant_landscaping': 'Landschaftsgestaltung mit dürreresistenten / einheimischen Pflanzen',
    't_high_efficiency_fixtures': 'Hocheffiziente / Trockene Vorrichtungen',
    't_installation_equipment': 'Installation von hocheffizienten Anlagen und Geräten',
    't_instructions': 'DE Instructions',
    't_consumption_loader': 'DE Consumption loader',
    't_bulk_add_template': 'DE Bulk Add Template',
    't_bulk_edit_template': 'DE Bulk Edit Template',
    't_installation_renewable': 'Installation von erneuerbaren Energieanlagen vor Ort',
    't_leak_detection_system': 'Dichtheitsprüfsystem',
    't_management_sys_upgrade': 'Upgrade/Austausch von Managementsystemen',
    't_selected_asset_stranding': 'DE Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'DE This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_meter_water_subsys': 'Wasserzähler für Teilsysteme',
    't_not_available': 'K. A.',
    't_occupier_eng_tech': 'Bewohner-Engagement / Informationstechnologien',
    't_ongoing_waste_monitoring': 'Laufende Überwachung der Abfallbilanz',
    't_onsite_waste_water_treatment': 'Abwasserwasserbehandlung vor Ort',
    't_recycling': 'Recycling',
    't_reuse_storm_water': 'Wiederverwendung von Regen- und/oder Grauwasser',
    't_smart_grid_tech': 'Smart Grid / intelligente Gebäudetechnologien',
    't_sys_commissioning': 'Inbetriebnahme oder Nachbesserung von Systemen',
    't_utility_type': 'Art der Versorgungsdienstleistung',
    't_wall_roof_inst': 'Wand- / Dachdämmung',
    't_waste_management': 'Abfallmanagement',
    't_waste_stream_audit': 'Überprüfung der Abfallströme',
    't_window_replacement': 'Erneuerung der Fenster',
    't_heatmap_tooltip_content_txt': '{0} Daten fehlen für {1} {2}',
    't_heatmap_tooltip_content_txt_partial': '{0} Daten fehlen für',
    't_heatmap_tooltip_content_txt_none': '{0} Alle gesammelten Daten für {1} {2}',
    't_missing_partial_data': 'Fehlende Teildaten',
    't_delete': 'Löschen',
    't_delete_action_title': 'Aktion löschen',
    't_delete_confirmation': 'Sind Sie sicher?',
    't_go': 'Los',
    't_error_ok': 'Okay',
    't_error_request_400': 'Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten.',
    't_error_request_401': 'Sie haben keine ausreichende Berechtigung, um auf diese Ressource zuzugreifen',
    't_page_not_found': 'DE Page not found',
    't_page_not_found_reason':'DE You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'DE There was a problem logging in.',
    't_page_auth_error_reason':'DE There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'DE Try logging in again',
    't_error_user_account_locked': 'Das Konto wird für die nächsten {lockedDuration} Sekunden gesperrt.',
    't_error_user_internal_login_issue': 'SIERA hat Serviceprobleme. Bitte versuchen Sie es später erneut.',
    't_password_expiry_info': 'Ihr Passwort ist abgelaufen. Bitte legen Sie ein neues Passwort an.',
    't_password_must_be_different': 'Das neue Passwort darf nicht mit dem abgelaufenen Passwort identisch sein',
    't_target_beaten': 'Ziel geschlagen!',
    't_lower_than_previous': 'Niedriger als im Vorjahr!',
    't_higher_than_previous': 'Höher als im Vorjahr',
    't_current': 'Aktueller Wert',
    't_target': 'Ziel',
    't_previous': 'Vorheriger Wert',
    't_variance': 'Abweichung',
    't_percentage_missing': ' % der Daten fehlen',
    't_target_missed': 'Ziel verfehlt',
    't_savings': 'Einsparungen',
    't_overspend': 'Überschreitung',
    't_annual_current_consumption': 'Jährlicher Stromverbrauch',
    't_annual_expected_consumption': 'Jährlicher erwarteter Verbrauch',
    't_agreed_action': 'Vereinbarte Aktion',
    't_applicable_action': 'Anwendbare Aktion',
    't_action_under_review': 'Aktion wird überprüft',
    't_notes_lowercase': 'Notizen',
    't_add_variance_note': 'Fügen Sie eine Notiz hinzu, um die Abweichung zu erklären',
    't_delete_warning': 'Möchten Sie diese Aktion wirklich löschen?',
    't_details': 'DE Details',
    't_clear': 'Leeren',
    't_groups': 'DE Groups',
    't_my_groups': 'DE My Groups',
    't_edit_user': 'DE Edit user',
    't_post': 'Posten',
    't_edited': 'bearbeitet',
    't_add_photo': 'DE Add photo',
    't_name': 'DE Name',
    't_company': 'DE Company',
    't_role': 'DE Role',
    't_email_address': 'DE Email address',
    't_required_fields': 'DE Required fields ',
    't_save_exit': 'DE Save and exit',
    't_close': 'Schließen',
    't_calendar': 'Kalender',
    't_chart': 'Grafik',
    't_exclamation': 'Ausrufezeichen',
    't_hand_right': 'Mit dem Zeigefinger zeigen',
    't_info': 'Info',
    't_no_notes': 'Keine Notizen zum Anzeigen',
    't_no_redirect_data': 'Keine Umleitungsdaten vom Server',
    't_old_password': 'Altes Passwort',
    't_confirm_password': 'Passwort bestätigen',
    't_property': 'Immobilie',
    't_refresh': 'Aktualisieren',
    't_show_hide_pass': 'Passwort anzeigen/verbergen',
    't_tick': 'Markieren',
    't_help': 'Hilfe',
    't_help_assistance': 'Wenn Sie Hilfe benötigen, klicken Sie bitte hier.',
    't_blue': 'Alle Daten erhoben',
    't_not_covered': 'Nicht abgedeckt',
    't_consumption': 'Verbrauch',
    't_add_action_plan_in_bulk': 'DE Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'DE Edit action plans in bulk',
    't_error_user_username': 'Die E-Mail-ID ist leer oder ungültig.',
    't_landlord_procured': 'Vermieter vermittelt',
    't_title_meter_view': 'Zähleransicht',
    't_provider': 'Anbieter',
    't_title_summary': 'Zusammenfassung',
    't_tenant_procured': 'Mieter vermittelt',
    't_yellow': 'Daten geschätzt',
    't_source': 'Quelle',
    't_reading': 'Ablesen',
    't_meters': 'Zähler',
    't_action_happen': 'Wenn die Aktion geschieht',
    't_action_completed': 'Wenn die Aktion erfolgt ist',
    't_date_format_check': 'Dieses Datumsformat wird nicht erkannt, bitte überprüfen',
    't_show_me': 'Anzeigen',
    't_months': 'Monate',
    't_month': 'Monat',
    't_end_of': 'Bis zum Ende von',
    't_completed_action': 'Abgeschlossene Aktion',
    't_review_date': 'Datum der Bewertung',
    't_note_post_warning': 'Klicken Sie auf \'Posten\', um Ihre Notiz vor dem Schließen hinzuzufügen',
    't_warning': 'DE Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_targets': 'DE Targets',
    't_targets_and_pathways': 'DE Targets & Pathways',
    't_string': '-',
    't_dq_landlord_pdf': 'DE SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'DE SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'DE SIERA Data Quality Meter.pdf',
    't_performance_excel':'DE SIERA Performance.xlsx',
    't_data_quality_zip':'DE SIERA Data Quality.zip',
    't_data_quality_excel':'DE SIERA Data Quality .xlsx',
    't_area':'DE Area',
    't_events_pfg_msg':'DE Peformance may have been affected by these events',
    't_last_edit':'DE Last edit',
    't_reports_create':'DE Create Report',
    't_completed_data_requirements':'DE Completed Data Requirements',
    't_reports_no_assets': 'DE No assets owned in the reporting year',
    't_reports_SFDR':'DE {count} SFDR fields',
    't_reports_missing_required':'DE Missing Required Fields',
    't_reports_missing_optional':'DE Missing Optional Fields',
    't_reports_data_completeness':'DE Data Completeness',
    't_reports_report_created_on':'De Report created on',
    't_reports_data_completeness_missing': 'DE Consumption Data Missing',
    't_reports_report_completeness':'DE Report Completeness',
    't_reports_report_completeness_missing': 'DE {count} Assets are missing required data.',
    't_reports_percentage_complete': 'DE {percentage}% complete',
    't_reports_percentage_complete_consumption_data': 'DE {percentage}% complete consumption data',
    't_reports_create_report_header': '{year} DE Report',
    't_reports_save': 'DE Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'DE Planning Permission Date',
    't_reports_assetnzeb_not_found': 'DE NZEB Threshold',
    't_reports_assetped_not_found': 'DE Primary Energy Demand',
    't_reports_giaM2_not_found': 'DE GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'DE GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'DE Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'DE Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'DE Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'DE Total Vertical Area',
    't_reports_gav_not_found': 'DE GAV',
    't_reports_fossilfuelexposure_not_found': 'DE Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'DE Waste Data',
    't_reports_constructionmaterialweight_not_found': 'DE Resource Consumption Data',
    't_reports_assetepc_not_found': 'DE EPC not found',
    't_reports_assetepc_not_valid': 'DE EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'DE EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'DE No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'DE The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'DE The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'DE Explanation',
    't_explanation_placeholder' : 'DE Type in explanation',
    't_actions_taken' : 'DE Actions Taken',
    't_actions_taken_placeholder' : 'DE Type in actions taken',
    't_adverse_impact' : 'DE Adverse Impact',
    't_fossil_fuels_exposure' : 'DE Fossil Fuels Exposure',
    't_energy_efficiency' : 'DE Energy Efficiency',
    't_energy_consumption' : 'DE Energy Consumption',
    't_resource_consumption' : 'DE Resource Consumption',
    't_adverse_impact_fossil_fuels' : 'DE Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency' : 'DE Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions' : 'DE Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption' : 'DE Energy Consumption Intensity',
    't_adverse_impact_waste' : 'DE Waste production in operations',
    't_adverse_impact_resource_consumption' : 'DE Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity' : 'DE Land artificialisation',
    't_impact_value' : 'DE Impact Value',
    't_impact_value_fossil_fuels': 'DE Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'DE Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'DE Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'DE Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'DE Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'DE Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'DE Share of non-vegetatedsurface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_back_t_a_users' :'DE Back to all users',
    't_members' :'DE Members',
    't_groups_none' : 'DE No Groups Found',
    't_assets_none' : 'DE No Assets Found',
    't_selected' :'DE selected',
    't_access' :' to access',
    't_upload_select_or_drop_file': 'DE Select or drop a file',
    't_upload_here_jpg': 'DE here (JPG)',
    't_upload': 'DE Upload',
    't_add_asset': 'DE Add asset',
    't_upload_image' :'DE Upload image',
    't_upload_footer_info': 'DE Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for' :'DE Choose resources for',
    't_admin': 'DE Admin',
    't_administrator': 'DE Administrator',
    't_user1': 'DE User1',
    't_user': 'DE User',
    't_users': 'DE Users',
    't_add_user': 'DE Add user',
    't_recycling_target_beaten': 'DE Recycling target beaten',
    't_more_recycled_than_previous_year': 'DE More recycled than previous year!',
    't_recycling_target_missed': 'DE Recycling target missed',
    't_less_recycled_than_previous_year': 'DE Less recycled than previous year',
    't_lease': 'DE Lease',
    't_next_choose_groups': 'DE Next - Choose Groups',
    't_next_choose_assets': 'DE Next - Choose Assets',
    't_choose_groups_for_new_user': 'DE Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'DE Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'DE Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'DE Choose users who will be able to access ‘{0}’',
    't_find_group': 'DE Find group',
    't_add_new_group': 'DE Add new group',
    't_created': 'DE Created',
    't_choose_assets_for_update_user': 'DE Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'DE Choose the assets this user will have access to',
    't_last_login': 'DE Last login',
    't_add_new_user': 'DE Add new user',
    't_find_user': 'DE Find user',
    't_home': 'DE Home',
    't_users_not_found': 'DE Sorry we couldn\'t find any users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'DE Problem getting access',
    't_full_name':'DE Full name',
    't_create_siera_account':'DE Create your SIERA account',
    't_password_not_match': 'DE Passwords do not match',
    't_title_cannot_signup': 'DE Signup failed',
    't_title_cannot_post_user_asset_access': 'Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'Update user asset access failed',
    't_retail': 'DE Retail',
    't_office': 'DE Office',
    't_industrial': 'DE Industrial',
    't_residential': 'DE Residential',
    't_hotel': 'DE Hotel',
    't_lodgingleisurerecreation': 'DE Lodging Leisure Recreation',
    't_education': 'DE Education',
    't_technologyscience': 'DE Technology Science',
    't_healthcare': 'DE Healthcare',
    't_mixeduseoffice': 'DE Mixed Use Office',
    't_asset_details': 'DE Asset details',
    't_select_sector': 'DE Select sector',
    't_select_gresb_sector': 'DE Select GRESB sector',
    't_gav_evaluation_date': 'DE GAV evaluation date',
    't_building_utilities': 'DE Building utilities present',
    't_select_building_utilities': 'DE Select building utilities present',
    't_operation_control': 'DE Operational control',
    't_select_operational_control': 'DE Select operational control',
    't_building_details': 'DE Building details',
    't_postcode': 'DE Postcode',
    't_city': 'DE City',
    't_select_city': 'DE Select a city',
    't_select_country': 'DE Select a country',
    't_select_region': 'DE Select a region',
    't_select_fund': 'DE Select a fund',
    't_add_details': 'DE Add details',
    't_select_date': 'DE Select date',
    't_asset_ownership': 'DE Fund ownership',
    't_sold_date': 'DE Sold date',
    't_year_built': 'DE Year built',
    't_select_asset_status': 'DE Select asset\'s current status',
    't_current_status': 'DE Current status',
    't_lifecycles_explanation': 'DE Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'DE Lifecycle',
    't_current_status_tooltip': 'DE What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'DE A unique name you assign to assets for easy identification within Siera.',
    't_land': 'DE Land',
    't_standing_investment': 'DE Standing Investment',
    't_new_construction': 'DE New Construction',
    't_major_renovation': 'DE Major Renovation',
    't_static_reporting_data': 'DE Static reporting data',
    't_periodic_reporting_details': 'DE Periodic reporting details',
    't_horizontal_artificial_areas': 'DE Horizontal artificial areas',
    't_horizontal_artificial': 'DE Horizontal artificial',
    't_vertical_artificial': 'DE Vertical artificial',
    't_vertical_artificial_areas': 'DE Vertical artificial areas',
    't_generic_number_message': 'DE {field} must be a number',
    't_generic_positivenumber_message': 'DE {field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'DE Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'DE Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'DE Must be before the year the asset was built (see Asset Details)',
    't_key_dates': 'DE Key dates',
    't_biodiversity_extended': 'DE Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_occupancy_extended': 'DE Track the proportion of lettable floor area occupied over time.',
    't_planning_permission_extended': 'DE Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_fossil_fuel_exposure_extended_edit_data': 'DE Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_ped_extended': 'DE Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_gav_extended': 'DE Track the gross value of the asset.',
    't_waste_contracts_extended': 'DE Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_report_data_checklist': 'DE Report data checklist',
    't_planning_permission': 'DE Planning Permission',
    't_periodic_reporting_data': 'DE Periodic reporting data',
    't_waste_contracts': 'DE Waste Contracts',
    't_report_data_checklist_info': 'DE Select a reporting framework to highlight data readiness issues.',
    't_epc': 'DE EPC',
    't_resource_consumption_extended': 'DE If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_users_groups': 'DE Users & Groups',
    't_asset_name_tc': 'DE Asset Name',
    't_asset_reference_tc': 'DE Asset Reference',
    't_asset_name': 'DE Asset name',
    't_asset_reference': 'DE Asset reference',
    't_find_address': 'DE Find address',
    't_add_address_manually': 'DE Add address manually',
    't_number_identifier': 'DE Number / Identifier',
    't_street': 'DE Street',
    't_town_city': 'DE Town/City',
    't_county': 'DE County',
    't_country': 'DE Country',
    't_region': 'DE Region',
    't_postcode_zip': 'DE Postcode/ZIP',
    't_sector_type': 'DE Sector type',
    't_gross_asset_value': 'DE Gross Asset Value (GAV)',
    't_fri': 'DE Full repairing and insuring lease',
    't_floor_areas': 'DE Floor Areas',
    't_gia': 'DE Gross Internal Area (GIA)',
    't_nla': 'DE Net Lettable Area (NLA)',
    't_cpa': 'DE Common Parts Area (CPA)',
    't_ext': 'DE External Area (EXT)',
    't_units': 'DE Units',
    't_units_desc': 'DE Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'DE Next - Add Key dates',
    't_form_error_message': 'DE Please fill all the required fields',
    't_asset_existing_group': 'DE This asset is part of a selected fund or group',
    't_organisation': 'DE Organisation',
    't_user_warning_message': 'DE Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': 'DE {0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'DE Confirmation',
    't_user_revocation_successful': 'DE {0} has been successfully revoked',
    't_resend_invite': 'DE Resend invite',
    't_instance': 'DE Instance',
    't_instance_different': 'DE Please select an instance which is not your current one.',
    't_change_instance': 'DE Change instance',
    't_change_instance_explanation': 'DE When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'DE Switch instance?',
    't_wrong_instance_explanation': 'DE You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'DE Re-login to',
    't_switch_to': 'DE Yes, switch to',
    't_could_not_find_groups': 'DE Sorry we couldn\'t find any Groups.',
    't_developer':'DE Developer',
    't_delete_group' : 'DE Delete Group',
    't_description' : 'DE Description',
    't_groups_not_found': 'DE Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'DE View all {0} resources',
    't_view_all_assets': 'DE View all {0} assets',
    't_fund_name': 'DE Fund name',
    't_investment_stage': 'DE Investment stage',
    't_search_scheme_asset_name': 'DE Search by scheme and asset name',
    't_green_building_certificates': 'DE Green Building Certificates',
    't_energy_rating_certification': 'DE Energy Rating Certification', 
    't_scheme': 'DE Scheme',
    't_reference_no': 'DE Reference no',
    't_rating': 'DE Rating',
    't_score': 'DE Score',
    't_unit': 'DE Unit',
    't_certified_floor_area': 'DE Certified floor area',
    't_valid_from_date': 'DE Valid from date',
    't_file_upload': 'DE File upload',
    't_uploaded_date': 'DE Upload date',
    't_gav': 'DE GAV',
    't_total_floor_area': 'DE Total floor area',
    't_contains': 'DE Contains',
    't_total_floor_area_gia': 'DE Total floor area (GIA)',
    't_financial_year_starts': 'DE Financial year starts',
    't_carbon_emissions': 'DE Carbon Emissions',
    't_energy_intensity': 'DE Energy intensity',
    't_gap_filled_data': 'DE gap-filled data',
    't_below_target': 'DE below target',
    't_above_target': 'DE above target',
    't_key_facts': 'DE Key facts',
    't_funds': 'DE Funds',
    't_my_organisations': 'DE My Organisations',
    't_net_zero_carbon': 'DE Net Zero Carbon',
    't_cco_fund_model': 'DE CCO Fund - Model',
    't_data-source_nzc': 'DE Data source: SIERA',
    't_kg_co2_year': 'DE kgCO₂e/m²/year',
    't_kwh_m2_year': 'DE kWh/m²/year',
    't_bau_ghg_intensity': 'DE Business as usual (BAU)',
    't_scientific_ghg_intensity': 'DE Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'DE Science based target (2.0C)',
    't_no_organisations_message': 'DE No Organisations Found',
    't_rise': 'DE rise',
    't_fall': 'DE fall',
    't_next_choose_funds':'DE Next - Choose Funds',
    't_find_fund': 'DE Find fund',
    't_choose_funds_for_user': 'DE Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'DE Choose the funds {0} has access to',
    't_proportion_missing_data': 'DE Portion of missing fund data',
    't_incomplete': 'DE Incomplete',
    't_total_missing': 'DE Total missing',
    't_revoke_access': 'DE Revoke access',
    't_grant_access' : 'DE Grant access',
    't_user_access_revoked' : 'DE This user\'s access has been revoked',
    't_user_revoke_confirm_message': 'DE This user will be deactivated and will no longer be able to log in.',
    't_revoke_user':'Revoke Access',
    't_actions_by_assets': 'DE Actions by asset ({0})',
    't_overdue': 'DE Overdue',
    't_items_per_page': 'DE Items per page',
    't_of': 'DE of',
    't_total_costs':'DE Total costs',
    't_non_recoverable':'DE Non-recoverable',
    't_un_costed':'DE Un-costed',
    't_gap_filled_data_above_target': 'DE Gap-filled data (above target)',
    't_actual_data_above_target': 'DE Actual data (above target)',
    't_actual_data_legend': 'DE Actual data',
    't_estimated_data_legend': 'DE Estimated data',
    't_incomplete_data_legend': 'DE Incomplete data',
    't_not_covered_data_legend': 'DE Not covered',
    't_gap_filled_data_legend': 'DE Gap-filled data',
    't_over_target_legend': 'DE Over target',
    't_show': 'DE Show',
    't_quarterly_data': 'DE Quarterly data',
    't_monthly_data': 'DE Monthly data',
    't_how_we_calculate': 'DE How we calculate this',
    't_fund_graph_carbon_explanation': 'DE Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin':'DE Site admin',
    't_my_account':'DE My account',
    't_my_profile':'DE My profile',
    't_aggregated_performance_assets_model': 'Aggregierte Leistung für im Modell verwendete Assets',
    't_agreed_overlay_text': 'DE In the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'DE In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'DE Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Aggregierte Datenqualität für im Modell verwendete Assets',
    't_based_on_baseline_year': 'Basierend auf dem Basisjahr',
    't_based_on_year': 'DE Based on year',
    't_carbon_intensity': 'Kohlenstoffintensität',
    't_cost_intensity': 'Kostenintensität',
    't_co2_emissions': 'CO₂e-Emissionen',
    't_feedback-panel-label': 'DE How could we improve this page?',
    't_feedback_form_header': 'DE Your feedback',
    't_feedback_form_info': 'DE Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'DE Yes, I am happy to be contacted to give more feedback',
    't_target_delta':'DE target/delta',
    't_sector':'DE Sector',
    't_no_data_available': 'DE There is no data available',
    't_feedback_success': 'DE Successfully Sent the feedback',
    't_add_feedback_failed': 'DE Add user feedback failed',
    't_about_scopes': 'Über Bereiche',
    't_about_scopes_info': 'Diese CO2e-Emissionsmetriken veranschaulichen die Auswirkungen von Aktivitäten, die für den direkten Betrieb eines Gebäudes erforderlich sind – d. h. Heizung, Beleuchtung usw. Sie umfassen Mieteremissionen (Scope 3) für Versorgungseinrichtungen, die von Gebäudemietern genutzt werden, beinhalten jedoch keine erweiterten Aktivitäten, die für das Geschäft des Mieters erforderlich sind.',
    't_more_details': 'Mehr Details',
    't_user_last_loggedIn_at' : 'DE Last logged in at {0} on {1}',
    't_total_data_missing':'DE Total data missing',
    't_landlord_data_missing':'DE Landlord data missing',
    't_tenant_data_missing':'DE Tenant data missing',
    't_total_waste': 'Totale Verschwendung',
    't_water_intensity': 'Wasserintensität',
    't_assets_wo_agreed_action':'DE Assets without agreed actions',
    't_assets_wo_completed_action':'DE Assets without completed actions',
    't_coverage_by_floor_area':'DE Floor area coverage',
    't_valid_certs_by_floor_area':'DE Valid certificates by floor area',
    't_expire_within_12_months':'DE Expire within 12 months',
    't_no_certs':'DE No certificates found',
    't_top_impact_cat':'DE Top 5 impact categories',
    't_user_not_logged_in':'DE User has not logged in yet.',
    't_total_data': 'DE Total data',
    't_landlord_proc_data': 'DE Landlord-procured data',
    't_tenant_proc_data': 'DE Tenant-procured data',
    't_landlord_proc_building': 'DE Landlord procures whole building',
    't_tenant_proc_building': 'DE Tenant procures whole building',
    't_otherfuelsandthermals': 'DE Other Fuels & Thermals',
    't_funds_none' : 'DE No Funds Found',
    't_funds_performance_cost_higher': 'DE higher than previous period',
    't_funds_performance_cost_lower': 'DE lower than previous period',
    't_gap_filled_data_NA': 'DE gap-filling not available',
    't_only_for_annual_data' : 'DE Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'DE Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'DE Non-recycled waste',
    't_total_carb_emissions': 'DE total carbon emissions',
    't_total_elec_used': 'DE total electricity used',
    't_total_gas_fuels_thermals': 'DE total gas fuels & thermals',
    't_total_water_used': 'DE total water used',
    't_total_recycled_waste': 'DE total recycled waste',
    't_fund_rise_than_previous_period': 'Anstieg gegenüber Vorperiode!',
    't_fund_fall_than_previous_period': 'fallen über Vorperiode!',
    't_estimated_saving': 'geschätzte Ersparnis',
    't_recycledwaste': 'Recycelter Abfall',
    't_nzc_available_siera': 'DE Net Zero Carbon {br} available in SIERA',
    't_epc_analysis': 'DE EPC Analysis',
    't_water_units': 'm³',
    't_assets_in_the_model' :'Vermögenswerte im Modell',
    't_date_of_export': 'DE Date of export',
    't_target_pathway_info': 'DE Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway':'DE Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway':'DE This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway':'DE Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'DE Target Pathway 1',
    't_action_based_carbon_pathway':'DE Action based pathway',
    't_action_based_energy_intensity_pathway': 'DE Action based energy intensity pathway',
    't_action_based_pathways':'DE Action-based pathways',
    't_energy_saving_action':'DE Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count':'DE {0} Agreed actions (required)',
    't_applicable_actions_count':'DE {0} Applicable actions (recommended)',
    't_science_based_target':'DE CRREM Science Based Targets (SBT)',
    't_SBT_option_1':'DE 1.5C SBT',
    't_SBT_option_2':'DE 2.0C SBT',
    't_custom_target_pathways':'DE Custom target pathways',
    't_tp_stranding_year':'DE CRREM Misalignment year in ',
    't_show_progress_towards_target_for':'DE Show progress towards target for ',
    't_cumulative': 'DE Cumulative',
    't_apply': 'DE Apply',
    't_grid_decarbonisation': 'DE grid decarbonisation',
    't_title_cannot_create_target_pathway': 'DE Create target pathway failed',
    't_improvement': 'DE Improvement',
    't_epc_available_siera': 'DE Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Abfall',
    't_model': 'Modell',
    't_models': 'Modelle',
    't_create_new_model': 'Erstellen Sie ein neues Modell' ,
    't_open_model': 'Öffnen Sie ein Modell' ,
    't_share_model': 'DE Share model',
    't_link' : 'DE Link',
    't_copy_link': 'DE Copy link',
    't_link_copied':'DE Link copied',
    't_share' : 'DE Share',
    't_duplicate_model': 'Doppelte Modell',
    't_export_config_data': 'Konfigurationsdaten exportieren',
    't_import_config_data': 'Konfigurationsdaten importieren',
    't_search': 'Suche',
    't_open': 'Offen',
    't_no_models_are_created_yet' : 'Es werden noch keine Modelle erstellt',
    't_default_model': 'Setzen Sie als Standardmodell',
    't_delete_model': 'Modell löschen',
    't_delete_yes_cancel': 'Lösch das! /',
    't_bau_stranding': 'DE BAU CRREM Misalignment',
    't_no_model': 'DE No models found',
    't_create_new_model_para': 'Dadurch wird ein Modell aus allen aktuellen, gültigen Vermögenswerten in diesem Fonds erstellt. Auf alle Vermögenswerte, die nicht über genügend Verbrauchsdaten verfügen, wird ein Branchen- und Länder-Benchmark angewendet.',
    't_create': 'Schaffen',
    't_name_required': 'Name ist erforderlich.',
    't_model_name_not_valid': 'DE Enter a valid model name',
    't_save_changes': 'Änderungen speichern',
    't_filter': 'DE Filter',
    't_all_sectors': 'DE All sectors',
    't_all_countries': 'DE All countries',
    't_assets_filter_result': 'DE {0} out of {1} assets will be displayed',
    't_assets_filter_count': 'DE filters selected:',
    't_assets_filter_title': 'DE Filter',
    't_about_gap_filled_data': 'DE About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>DE Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'DE Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'DE No results found.',
    't_no_graph_data': 'DE No graph data',
    't_getting_scope_data': 'DE Getting Scope Data...',
    't_creating_default_scope': 'DE Creating default scope...',
    't_rise_over_previous_period': 'DE rise over previous period',
    't_sort': 'Sortieren',
    't_lowest_first': 'Niedrigste zuerst',
    't_highest_first': 'Höchster zuerst',
    't_nzc_data_missing': 'DE Data missing',
    't_nzc_carbon_intensity': 'DE Carbon intensity',
    't_current_action_plan': 'DE Current Action Plan',
    't_current_epc_analysis': 'DE Current EPC Analysis',
    't_sold': 'DE SOLD',
    't_data_warning': 'DE DATA WARNING',
    't_siera_experience_feedback': 'DE I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'DE assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'DE These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'DE View these assets',
    't_export_model_explanation_text': 'DE You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'DE You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'DE The export file name must not contain more than 50 characters', 
    't_top': 'DE Top',
    't_import_model_explanation_text': 'DE To import asset data from Excel you must use the {0} template',
    't_import': 'DE Import',
    't_drag_file': 'DE Drag file to upload, or',
    't_select_file': 'DE Select a file',
    't_import_create_explanation': 'DE What do you want the new NZC model to be called?',
    't_upload_success_msg': 'DE has been successfully uploaded',
    't_upload_error_msg': 'DE There are problems with your file',
    't_row': 'DE Row',
    't_copy_clipboard': 'DE Copy to clipboard',
    't_select_valid_file': 'DE Select a valid file',
    't_copied': 'DE Copied',
    't_loading': 'DE Loading',
    't_procurement_tabs_explanation_title': 'DE What do these categories mean?',
    't_data_categories': 'DE Data Categories',
    't_about_procurement_data_categories': 'DE <p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'DE This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'DE This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'DE Delete Target Pathway',
    't_delete_target_pathway_message': 'DE Are you sure you want to delete this pathway?',
    't_add_another_target_pathway': 'DE Add another Target Pathway',
    't_add_a_target_pathway': 'DE Add a Target Pathway',
    't_target_pathway': 'DE Target pathway',
    't_milestone_years': 'DE Milestone years',
    't_group_leaving_confirmation' : 'DE Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason' : 'DE What is your reason for leaving the group?',
    't_request':'DE Request',
    't_leave_group':'DE Request to leave the group',
    't_add_group': 'DE Create new Group',
    't_target_warning': 'DE The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'DE Chart options',
    't_plot_data_assets': 'DE Plot data for individual assets',
    't_display_benchmark': 'DE Display benchmark',
    't_data_source': 'DE Data source',
    't_show_progress_relative': 'DE Show progress relative to target for',
    't_base_line_year': 'DE Baseline year',
    't_raw_data': 'DE Raw data',
    't_uplifted_data': 'DE Uplifted data',
    't_uplifted_estimated_data': 'DE Uplifted/estimated data',
    't_complete_data': 'DE Complete data',
    't_siera': 'DE SIERA',
    't_imported': 'DE Imported',
    't_benchmark_data': 'DE Benchmarked data',
    't_choose_assets_group_for_update_user': 'DE Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'DE Choose assets for this group to access',
    't_previous_period' : 'DE Previous period',
    't_this_period' : 'DE This period',
    't_gap_filled' : 'DE Gap filled',
    't_combined' : 'DE Combined',
    't_actual_and_supplier_estimated' : 'DE Actual & supplier estimated',
    't_recycled_waste' : 'DE Recycled waste',
    't_recycled_waste_previous' : 'DE Recycled waste (previous)',
    't_group_name': 'DE Group name',
    't_email_leave_group' : 'DE To request to leave this group, please email',
    't_data_shown': 'DE Data shown',
    't_show_details': 'DE Show details',
    't_hide_details': 'DE Hide details',
    't_view_asset': 'DE View asset',
    't_gia_small_form': 'DE GIA',
    't_asset_ref': 'DE Asset ref',
    't_stranding_year': 'DE CRREM Misalignment year',
    't_energy_saving': 'DE Energy-saving actions',
    't_target_stranding_year':'DE Target pathway CRREM Misaligned in ',
    't_bau_stranding_year':'DE BAU CRREM Misalignment in ',
    't_next_users': 'DE Next -Choose Users',
    't_delete_group_msg':'DE Are you sure you want to delete this group?',
    't_edit_group':'DE Edit group : ',
    't_all_assets': 'DE All assets',
    't_not_included_in_model': 'DE Not included in current NZC model',
    't_including_gap_filled': 'DE Including gap-filled data',
    't_excluding_gap_filled': 'DE Excluding gap-filled data',
    't_asset_without_energy_saving_action' : 'DE Assets with no energy saving actions specified',
    't_sold_assets': 'DE Sold assets',
    't_sold_label': 'DE Asset sold',
    't_asset_status': 'DE Asset status',
    't_no_data_for_previous_period': 'DE no data for previous period',
    't_x_axis_scale': 'DE X-axis scale',
    't_y_axis_scale': 'DE Y-axis scale',
    't_autoscale': 'DE Autoscale',
    't_from': 'DE From',
    't_to': 'DE to',
    't_min': 'DE Min',
    't_max': 'DE Max',
    't_selected_asset': 'DE Selected asset',
    't_no_gresb_sector_error_message': 'DE Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'DE Asset has critical information missing',
    't_asset_sold_date_message': 'DE Asset sold in',
    't_more_recycled': 'DE more recycled than previous period',
    't_less_recycled': 'DE less recycled than previous period',
    't_required_group_field': 'DE Required field',
    't_form_group_error_message': 'DE Please fill the required field',
    't_upload_nzc_data_failed': 'DE Upload NZC import data failed',
    't_nzc_file_uploaded_success': 'DE {0} file successfully uploaded',
    't_default_model_name': 'DE Default model',
    't_metric':'DE Metric',
    't_imperial':'DE Imperial',
    't_energy_intensity_popup_header': 'DE Coming soon',
    't_energy_intensity_popup_body': 'DE Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'DE Coming soon',
    't_epc_analysis_popup_body': '<p> DE Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'DE Model notes',
    't_setting_default_model_failed': 'DE Setting model as default failed',
    't_set_as_default': 'DE Set as Default Model',
    't_set_as_default_info': 'DE This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'DE This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_nzc_default_text': 'DE NZC default',
    't_unable_to_plot_NZC_chart': 'DE Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'DE No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'DE Please {contactEvora} if you require help.',
    't_contact_Evora' : 'DE contact Evora',
    't_Contact_Evora' : 'DE Contact Evora',
    't_model_no_data_available' : 'DE No data available',
    't_select_target_pathway' : 'DE Select Target Pathway',
    't_define_target_pathway':'DE Define a custom target pathway',
    't_name_must_not_exceed_100_characters' : 'DE The model name must not contain more than 100 characters',
    't_no_meter_information': 'DE No meter information.',
    't_no_assets' : 'DE 0 assets',
    't_show_stranding_dates':'DE Show CRREM Misalignment dates',
    't_default': 'DE Default',
    't_current_model': 'DE Current model',
    't_based_on': 'DE Based on',
    't_past_3_months': 'DE Past 3 months',
    't_past_6_months': 'DE Past 6 months',
    't_current_year_till_previous_month': 'DE Current year till previous month',
    't_model_with_same_name_exists': 'DE Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'DE Apply Filter to view these assets',
    't_session_expiry': 'DE Your session is going to expire soon. Would you like to log out?',
    't_session_expiry_warning': 'DE For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'DE Do you want to stay logged in?',
    't_stay_logged_in': 'DE Stay logged in',
    't_log_out_now': 'DE Log out now',
    't_jpeg': 'DE JPEG',
    't_svg': 'DE SVG',
    't_currency': 'DE Currency',
    't_nzc_session_model_deleted': 'DE {0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_estimated_savings' : 'DE Estimated Savings',
    't_procured_by': 'DE Procured by',
    't_area_covered': 'DE Area Covered',
    't_shared_services': 'DE Shared services',
    't_scope_index': 'DE Scope {0}',
    't_import_model_explanation_note_link': 'DE To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'DE Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'DE You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'DE Add',
    't_btn_update_and_add': 'DE Update and add',
    't_nzc_data_availability': 'DE Data availability',
    't_energy_star_score': 'DE Energy Star Score',
    't_energy_star_last_synced': 'DE This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_valid_ratings_by_floor_area':'DE Valid scores by floor area',
    't_certified_assets_by_floor_area':'DE Certified assets by floor area',
    't_ratings_last_sync_on' : 'DE Scores last synced on {0}',
    't_certified':'DE certified',
    't_energy_star_analysis': 'DE Energy Star Analysis',
    't_kg_co2_m2_yr': 'DE kgCO₂e/m²/yr',
    't_kg_co2_yr': 'DE kgCO₂e/yr',
    't_kWh_m2_yr': 'DE kWh/m²/yr',
    't_reports_resource_consumption_not_found_msg': 'DE {areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': 'DE {areas} cannot be empty.',
    't_totalweight_not_found_msg': 'DE {areas} cannot be empty.',
    't_startdate_not_found_msg': 'DE {areas} cannot be empty.',
    't_enddate_not_found_msg': 'DE {areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'DE Sustainable Weight',
    't_reports_totalweight_not_found': 'DE Total Weight',
    't_reports_startdate_not_found': 'DE Start Date',
    't_reports_enddate_not_found': 'DE End Date',
    't_energy_star_set':'DE Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'DE Hit Post to add your note before closing',
    't_energy_star_integration':'DE Energy Star Integration',
    't_es_sub_text': 'DE Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'DE Learn more',
    't_es_step_title': 'DE Step {0} of {1}: {2}',
    't_es_step_one': 'DE Log into ES Portfolio Manager and add Evora_Siera as a contact',
    't_es_step_two': 'DE Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'DE Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'DE Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': 'DE {0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'DE Log into your Energy Star Portfolio Manager',
    't_es_prompted_username' : 'DE When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button' : 'DE I have added Evora_Siera as a contact',
    't_es_requested_account_text': 'DE {0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id' : 'DE Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection' : 'DE Confirm connection',
    't_es_not_recognise_request': 'DE If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'DE Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'DE Sharing',
    't_es_select_share': 'DE Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'DE Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'DE I have set up sharing',
    't_es_available_assets': 'DE These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'DE If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'DE Contact Support',
    't_es_confirm': 'DE Confirm',
    't_es_asset_in_siera':'DE Asset in SIERA',
    't_es_asset_in_portfolio_manager':'DE Respective Asset in ES Portfolio Manager',
    't_es_success' : 'DE You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'DE Success',
    't_continue':'DE Continue',
    't_action_based_pathway_stranding':'DE Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'DE Fund carbon intensity',
    't_fund_energy_intensity': 'DE Fund energy intensity',
    't_es_step_three_error':'DE Error: DE We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error':'DE Error: DE We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error':'DE Error: DE Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error':'DE Error: DE Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'DE Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'DE Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'DE These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': 'DE {0} of {1} Assets matched',
    't_es_sync_frequency': 'DE Sync frequency',
    't_es_match_more_assets': 'DE Match more Assets',
    't_address': 'DE Address',
    't_last_sync': 'DE Last Sync',
    't_jpeg_small': 'DE Small JPEG',
    't_png_small': 'DE Small PNG',
    't_jpeg_medium': 'DE Medium JPEG',
    't_png_medium': 'DE Medium PNG',
    't_jpeg_large': 'DE Large JPEG',
    't_png_large': 'DE Large PNG',
    't_max_length_30':'DE Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name':'DE The custom pathway name must be unique',
    't_tp_name_validation': 'DE Name can only contain numbers & letters',
    't_monthly': 'DE Monthly',
    't_yearly': 'DE Yearly',
    't_mean_carbon_intensity': 'DE Mean carbon intensity',
    't_data_availability_assets': 'DE Data availability of assets',
    't_uplifted': 'DE Uplifted',
    't_benchmark': 'DE Benchmarked',
    't_target_pathway_2': 'DE Target Pathway 2',
    't_target_pathway_3': 'DE Target Pathway 3',
    't_unique_custom_target_pathway_name':'DE Custom pathway name must be unique',
    't_tp_name_empty':'DE Custom pathway name cannot be empty',
    't_example': 'DE E.g.',
    't_no_assets_to_match': 'DE No assets to match.',
    't_intensity':'DE Intensity',
    't_portfolio_excel': 'DE SIERA Portfolio.xlsx',
    't_excel_tab_name': 'DE Assets Raw Data',
    't_client_name': 'DE Client',
    't_agent_name': 'DE Agent',
    't_purchase_date': 'DE Purchase date',
    't_sale_date': 'DE Sale date',
    't_property_status': 'DE Property Status',
    't_gresb_sector': 'DE GRESB sector',
    't_energy_star_sector': 'DE Energy Star sector',
    't_select_energy_star_sector': 'DE Select Energy Star sector',
    't_gresb_management_status': 'DE GRESB management status',
    't_gia_m_sqrt': 'DE GIA (m2)',
    't_nla_m_sqrt': 'DE NLA (m2)',
    't_cpa_m_sqrt': 'DE CPA (m2)',
    't_is_cpa_estimated': 'DE Is CPA estimated?',
    't_gas_expected': 'DE Gas expected',
    't_water_expected': 'DE Water expected',
    't_electricity_expected': 'DE Electricity expected',
    't_oil_expected': 'DE Oil expected',
    't_district_heating_expected': 'DE District heating expected',
    't_district_cooling_expected': 'DE District cooling expected',
    't_fund_performance_excel': 'DE SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'DE View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report':'DE Fund Carbon Performance Report',
    't_fund_electricity_performance_report':'DE Fund Electricity Performance Report',
    't_fund_thermals_performance_report':'DE Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report':'DE Fund Waste Performance Report',
    't_fund_water_performance_report':'DE Fund Water Performance Report',
    't_fund_level_summary':'DE Fund Level Summary',
    't_total_consumption_excel':'DE Total Consumption (MWh)',
    't_asset_level_total_consumption_excel':'DE Total Consumption ({0})',
    't_total_emission_excel':'DE Total Emissions ({0})',
    't_total_consumption':'DE Total Consumption ({0})',
    't_total_carbon_emission_excel':'DE Total Carbon Emission (T)',
    't_gap_filled_data_excel':'DE Gap Filled Data (%)',
    't_over_under_target_excel':'DE Over/Under target (%)',
    't_time_period_excel':'DE Time Period',
    't_asset_information_excel':'DE Asset Information',
    't_floor_area_excel':'DE Floor Area (m2)',
    't_floor_area_excel_imperial':'DE Floor Area (ft2)',
    't_occupancy_excel':'DE Occupancy (%)',
    't_intensity_excel':'DE Intensity ({0})',
    't_carbon_intensity_excel':'DE Carbon intensity ({0})',
    't_recycled_waste_excel':'DE Recycled Waste (t)',
    't_total_waste_excel':'DE Total Waste (t)',
    't_recycled_percentage_excel':'DE % Recycled',
    't_recycled_percentage_change_excel':'DE % change in recycled waste',
    't_post_code': 'DE Post code',
    't_interim_target':'DE Interim target',
    't_month_to_end_of':'DE month to end of', // to be updated
    't_months_to_end_of':'DE months to end of', // to be updated
    't_energy_intensity_excel':'DE Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'DE Update target pathway failed',
    't_title_delete_target_pathway_failed': 'DE Delete target pathway failed',
    't_ton_co2_yr': 'DE tCO₂e/yr',
    't_average_carbon_intensity':'DE Average Carbon intensity',
    't_average_energy_intensity':'DE Average Energy intensity',
    't_average_cost_intensity':'DE Average Cost intensity',
    't_performance_assets_model':'DE Performance for assets used in model',
    't_energy_intensity_nzc': 'DE Energy intensity',
    't_selected_utility_excel':'DE {0} - EXCEL',
    't_all_utilities_excel':'DE All utilities - EXCEL',
    't_gas_fuels_thermals': 'DE Gas, fuels and thermals',
    't_total_energy_consumption': 'DE Total energy consumption (MWH)',
    't_fund_performance_report':'DE Fund Performance Report',
    't_energy_summary': 'DE Energy Summary',
    't_remove_match': 'DE Remove match',
    't_remove': 'DE Remove',
    't_action_by_impact_excel':'DE Actions by impact - EXCEL',
    't_action_by_status_excel':'DE Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'DE Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'DE Are you sure you want to cancel the integration {0} set up process?',
    't_es_reset_warning_header_message': 'DE Cancel integration set up process',
    't_es_reset_warning_yes': 'DE Yes, cancel',
    't_tenant_data_quality':'DE Tenant data quality',
    't_landlord_data_quality': 'DE Landlord data quality',
    't_tenant_procured_assets':'DE Tenant procured assets',
    't_landlord_procured_assets':'DE Landlord procured assets',
    't_actual_percentage':'DE Actual (%)',
    't_supplier_estimated_percentage':'DE Supplier estimated (%)',
    't_incomplete_percentage':'DE Incomplete (%)',
    't_not_covered_percentage':'DE Not covered (%)',
    't_total_missing_percentage':'DE Total missing (%)',
    't_managing_agent':'DE Managing agent',
    't_portion_of_missing_fund_data_percentage':'DE Portion of missing fund data (%)',
    't_dq_floor_area_landlord':'DE Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant':'DE Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data':'DE Floor area for which you have no data ({0})',
    't_dq_floor_area':'DE Floor area ({0})',
    't_fund_data_quality_excel':'DE Fund Data Quality Excel',
    't_fund_data_quality_report':'DE Fund Data Quality Report',
    't_es_reset_warning_no': 'DE Stay on Step 4',
    't_upload_consumption_data': 'DE Upload consumption data',
    't_upload_action_plans': 'DE Upload action plans',
    't_action_plan_point_two': 'DE Upload actions data',
    't_consumption_upload_sub_text': 'DE Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'DE You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'DE Download and populate your consumption template',
    't_action_plan_upload_template_point_one': 'DE Generate and populate your template',
    't_consumption_upload_point_one_subtext': 'DE Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'DE Populate the template with list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'DE Generate template',
    't_upload_template': 'DE Upload template',
    't_action_plan_upload_point_two_subtext': 'DE When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'DE Data upload successful',
    't_consumption_upload_success_text_one': 'DE Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'DE Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': 'DE {0} action plans have been uploaded. Uploaded on {1} by {2}  ',
    't_action_upload_success_text_two': 'DE Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'DE Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'DE Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'DE We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'DE Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'DE Return home',
    't_return_action':'DE Return to Actions',
    't_upload_bulk_consumption': 'DE Bulk add consumption',
    't_upload_bulk_action_plan': 'DE Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'DE OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'DE Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'DE You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'DE Action Plan Report',
    't_total_agreed_actions': 'DE Total agreed actions',
    't_un_costed_actions': 'DE Un-costed actions',
    't_unit_of_measurement' : 'DE Unit of measurement',
    't_overdue_actions' : 'DE Overdue actions',
    't_under_review_actions': 'DE Actions under review',
    't_fund_agreed_actions_summary' : 'DE Fund level summary of agreed actions',
    't_fund_overdue_actions_summary' : 'DE Fund level summary of overdue actions',
    't_fund_completed_actions_summary' : 'DE Fund level summary of completed actions',
    't_fund_applicable_actions_summary' : 'DE Fund level summary of applicable actions',
    't_fund_under_review_actions_summary' : 'DE Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'DE Fund ActionPlan (by status)',
    't_no_fund_actions_with_status' : 'DE This fund has no actions with this status',
    't_actions_per_year': 'DE Actions per year',
    't_asset_performance_excel': 'DE Asset performance EXCEL',
    't_gas_fuels_performance': 'DE Gas, Fuels & Thermals performance report',
    't_water_performance': 'DE Water performance report',
    't_waste_performance':'DE Waste performance report',
    't_carbon_performance': 'DE Carbon performance report',
    't_asset_performance_export': 'DE Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'DE Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'DE Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'DE Gap-filled energy data (%)',
    't_current_energy_consumption': 'DE Current energy consumption (KWH)',
    't_generate_your_template': 'DE Generate your consumption template',
    't_generate_your_action_plan_template': 'DE Generate your action plan template',
    't_asset_details_excel':'DE Asset details EXCEL',
    't_no_data_to_export':'DE No data available to export',
    't_total_carbon_emissions': 'DE Total Carbon Emissions ({0})',
    't_landlord_summary':'DE Landlord summary',
    't_tenant_summary':'DE Tenant summary',
    't_dq_floor_area_gia' : 'DE Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel':'DE Fund ActionPlan (by impact)',
    't_total_actions_for_category':'DE Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary':'DE Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary':'DE Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary':'DE Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary':'DE Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary':'DE Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary':'DE Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary':'DE Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary':'DE Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary':'DE Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary':'DE Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary':'DE Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title':'DE Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title':'DE Actions with building performance impact',
    't_actions_with_community_engagement_impact_title':'DE Actions with community engagement impact',
    't_actions_with_energy_impact_title':'DE Actions with energy impact',
    't_actions_with_governance_recommended_impact_title':'DE Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title':'DE Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title':'DE Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title':'DE Actions with tenant engagement impact',
    't_actions_with_waste_impact_title':'DE Actions with waste recycling impact',
    't_actions_with_water_impact_title':'DE Actions with water impact',
    't_actions_with_other_impact_title':'DE Actions with other impact',
    't_fund_level_energy_summary':'DE Fund level energy summary',
    't_asset_information':'DE Asset information',
    't_total_floor_area_m2':'DE Total Floor Area (m2)',
    't_tenant_controlled_asset':'DE Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg':'DE Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh':'DE Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg':'DE Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh':'DE Previous annual consumption (KWH)',
    't_intensity_unit':'DE Intensity ({0})',
    't_benchmark_kwh/m2':'DE Benchmark (kWh/m2)',
    't_benchmark_m3/m2':'DE Benchmark (m3/m2)',
    't_landfill_unit':'DE Landfill ({0})',
    't_incinerated':'DE Incinerated ({0})',
    't_recycled_unit':'DE Recycled ({0})',
    't_reuse_unit':'DE Reuse ({0})',
    't_anaerobic_t':'DE Anaerobic (t)',
    't_hazardous_t':'DE Hazardous (t)',
    't_unknown_unit':'DE Unknown ({0})',
    't_total_t':'DE Total (t)',
    't_energy_performance_report':'DE Energy Performance Report',
    't_electricity_performance_report':'DE Electricity Performance Report',
    't_gas_fuels_thermals_report':'DE Gas, Fuels & Thermals Performance Report',
    't_water_performance_report':'DE Water Performance Report',
    't_waste_performance_report':'DE Waste Performance Report',
    't_carbon_performance_report':'DE Carbon Performance Report',
    't_unsaved_changes': 'DE Unsaved changes',
    't_unsaved_changes_message': 'DE Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'DE Leave without saving',
    't_save_and_leave': 'DE Save and leave',
    't_support_guides': 'DE Support Guides',
    't_release_notes': 'DE Release Notes',
    't_asset_performance_report': 'DE Asset Performance Report',
    't_is_the_asset_tenant': 'DE Is the asset tenant controlled?',
    't_current_consumption': 'DE Current consumption',
    't_current_year_gap': 'DE Current year gap filled Data (%)',
    't_previous_annual_consumption': 'DE Previous annual consumption',
    't_previous_year_gap': 'DE Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'DE Unit of measurement for consumption',
    't_benchmark_name': 'DE Benchmark',
    't_unit_of_measurement_for_intensity': 'DE Unit of measurement for intensity',
    't_kwh_m2': 'DE kWh/m2',
    't_m3': 'DE m3',
    't_m3_m2': 'DE m3/m2',
    't_kg_co2_m2': 'DE kg CO2e/m2',
    't_current_total_waste': 'DE Current Total Waste (t)',
    't_current_recycled_waste': 'DE Current Recycled Waste (t)',
    't_current_recycled': 'DE Current % Recycled',
    't_previous_total_waste': 'DE Previous Total Waste (t)',
    't_previous_recycled_waste': 'DE Previous Recycled Waste (t)',
    't_previous_recycled': 'DE Previous % Recycled',
    't_agreed_and_applicable_actions': 'DE Agreed and applicable actions',
    't_generate_template_user_text': 'DE The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'DE Type of record',
    't_template_to_generate': 'DE Template to generate',
    't_time_period': 'DE Time period',
    't_time_period_user_text': 'DE The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'DE Meters included in template',
    't_file_name': 'DE File name',
    't_include_inactive_meters': 'DE Include inactive meters',
    't_generate': 'DE Generate',
    't_landlord_procured_meters': 'DE Landlord procured meters',
    't_tenant_procured_meters': 'DE Tenant procured meters',
    't_both': 'DE Both',
    't_asset_action_plans_excel': 'DE Asset action plans EXCEL',
    't_asset_data_quality_excel': 'DE Asset data quality EXCEL',
    't_benchmark_line': 'DE Benchmark line',
    't_no_benchmark': 'DE No Benchmark',
    't_benchmark_office_ac': 'DE BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'DE BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'DE consumption upload',
    't_action_upload': 'DE action upload',
    't_bulk_consumption_instruction_header':'DE SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'DE SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'DE SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note':'DE Please note:',
    't_bulk_consumption_instruction_one': 'DE The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'DE In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'DE We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'DE Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'DE We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'DE This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'DE If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight':'DE If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'DE This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'DE This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'DE In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'DE In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'DE Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'DE Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'DE Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'DE Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'DE If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name':'DE This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility':'DE The utility type this meter is associated with.',
    't_bulk_consumption_tooltip_area_covered':'DE The area of the property which this meter covers.',
    't_bulk_action_plan_edit_tooltip_actionId': 'DE DO NOT EDIT THIS',
    't_bulk_consumption_tooltip_is_active':'DE Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number':'DE The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name':'DE The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date':'DE The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date':'DE The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin':'DE The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption':'DE Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated':'DE Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'DE Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'DE Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'DE Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'DE Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'DE Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'DE Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'DE Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'DE Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_import_model_explanation_note_asset_name': 'DE You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'DE EvoraNZCData',
    't_summary':'DE Summary',
    't_asset_performance_excel_file_name':'DE SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh':'DE Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh':'DE Total Energy Consumption (kWh)',
    't_action_export_from_portfolio_view': 'DE Actions export from portfolio view',
    't_summary_of_agreed_action': 'DE Summary of agreed actions',
    't_total_overdue_action': 'DE Total overdue actions',
    't_total_completed_action': 'DE Total completed actions',
    't_total_applicable_action': 'DE Total applicable actions',
    't_total_action_under_review': 'DE Total actions under review',
    't_action_estimated_savings': 'DE Estimated savings',
    't_action_area_covered': 'DE Area covered',
    't_summary_of_overdue_action': 'DE Summary of overdue actions',
    't_summary_of_completed_actions': 'DE Summary of completed actions',
    't_summary_of_applicable_actions': 'DE Summary of applicable actions',
    't_summary_of_actions_under_review': 'DE Summary of actions under review',
    't_no_assets_selected_actions_status': 'DE The assets selected have no actions with this status',
    't_missing_fund_data_weighted_by_floor_area': 'DE Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'DE Floor area not covered ({0})',
    't_floor_area_not_covered_percentage': 'DE Floor area not covered (%)',
    't_portfolio_data_quality_report': 'DE Data Quality Report',
    't_portfolio_data_quality_file_name': 'DE Portfolio Data Quality Report',
    't_current_energy_consumption_kwh':'DE Current Energy Consumption (kWh)',
    't_level_of_details_by_asset':'DE By asset',
    't_level_of_details_by_meter':'DE By meter',
    't_time_period_granularity_annual': 'DE Annual',
    't_time_period_granularity_monthly': 'DE Monthly',
    't_level_of_detail':'DE Level of detail',
    't_time_period_granularity':'DE Time period granularity',
    't_name_must_not_exceed_50_characters' : 'DE The model name must not contain more than 50 characters',
    't_current_reporting_period_total_energy_consumption':'DE Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage':'DE Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption':'DE Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage':'DE Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area':'DE Total Asset Floor Area ({0})',
    't_reporting_period':'DE Reporting Period',
    't_reporting_period_gap_filler_data_percentage':'DE Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions':'DE Reporting Period Carbon Emissions ({0})',
    't_utility_meter_unavailable': 'DE Unavailable: no meter for',
    't_current_reporting_period_total_consumption':'DE Current Reporting Period Total Consumption ({0})',
    't_current_reporting_period_gap_filled_data_percentage':'DE Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption':'DE Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage':'DE Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste':'DE Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste':'DE Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled':'DE Current % Recycled',
    't_previous_reporting_period_total_waste':'DE Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste':'DE Hazardous Waste ({0})',
    't_non_hazardous_waste':'DE Non-hazardous Waste ({0})',
    't_total_waste_generated':'DE Total Waste Generated ({0})',
    't_waste_to_energy_unit':'DE Waste to energy ({0})',
    't_waste_generated':'DE Waste Generated',
    't_destination':'DE Destination',
    't_current_reporting_period_total_emissions':'DE Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions':'DE Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste':'DE Previous Reporting Period Recycled Waste ({0})',
    't_emissions':'DE Emissions',
    't_current_total_carbon_emissions':'DE Current total Carbon Emissions ({0})',
    't_scope_1_emissions':'DE Scope 1 emissions ({0})',
    't_scope_2_emissions':'DE Scope 2 emissions ({0})',
    't_scope_3_emissions':'DE Scope 3 emissions ({0})',
    't_current_period_consumption_with_gapFilled_data' : 'DE Current period consumption ({0})',
    't_current_period_gapFilled_data' : 'DE Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data' : 'DE Previous period consumption ({0})',
    't_previous_period_gapFilled_data':'DE Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'DE Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'DE Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'DE Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'DE Previous energy consumption ({0})',
    't_import_file_error_message': 'DE The import file name must not contain more than 50 characters',
    't_no_export_data_available': 'DE The assets selected have no data available for this utility within the specified time frame.',
    't_current_reporting_period_gap_filled_energy_data_percentage':'DE Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage':'DE Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name':'DE Meter name',
    't_serial_number': 'DE Serial number',
    't_comment':'DE Comment',
    't_active_from': 'DE Active from',
    't_active_to': 'DE Active to',
    't_is_this_a_submeter':'DE Is this a submeter?',
    't_floor_area_served_by_meter': 'DE Floor area served by Meter ({0})',
    't_green_tariff': 'DE Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'DE Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'DE Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served':'DE Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'DE Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'DE Waste disposal route reference',
    't_contractor': 'DE Contractor',
    't_waste_type': 'DE Waste Type',
    't_previous_period_carbon_emissions':'DE Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'DE Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information':'DE Meter Information',
    't_actions_date': 'Based on {0}',
    't_export_performance_excel': 'DE Export performance - EXCEL',
    't_water_intensity_excel': 'DE Water Intensity ({0})',
    't_export_data_quality_excel': 'DE Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data' : 'DE Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data' : 'DE Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'DE Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'DE Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'DE Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions':'DE In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'DE In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'DE Data below target',
    't_gap_filled_data_below_target': 'DE Gap-filled data below target',
    't_data_above_target': 'DE Data above target',
    't_gap_filled_data_above_target_updated': 'DE Gap-filled data above target',
    't_data_below_previous_period': 'DE Data below previous period',
    't_gap_filled_data_below_previous_period': 'DE Gap-filled data below previous period',
    't_data_above_previous_period': 'DE Data above previous period',
    't_gap_filled_data_above_previous_period': 'DE Gap-filled data above previous period',
    't_carbon_scope_info': '<p><b>DE Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'DE Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_industry_standard_benchmark': 'DE Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'DE Variance against Industry Standard Benchmark (%)',
    't_asset_nzc_action_based_target_pathway_info' : 'DE Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info' : 'DE Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'DE kWh/m²/yr',
    't_assets_with_scores':'DE Assets with scores',
    't_gav_coverage':'DE GAV coverage',
    't_date_completed':'DE Date completed',
    't_total_emissions': 'DE Total Emissions',
    't_scope1_emissions': 'DE Scope 1 Emissions',
    't_scope2_emissions': 'DE Scope 2 Emissions',
    't_scope3_emissions': 'DE Scope 3 Emissions',
    't_missing_fund_data_weighted': 'DE Missing fund data, weighted by floor area (%)',
    't_commercial':'DE Commercial',
    't_no_data_for_comparison':'DE No data for comparison',
    't_landlord_tenant_split':'DE Landlord/Tenant split',
    't_scope_breakdown': 'DE Scope breakdown',
    't_scope1_landlord':'DE Scope 1 (Landlord)',
    't_scope2_landlord':'DE Scope 2 (Landlord)',
    't_scope3_tenant':'DE Scope 3 (Tenant)',
    't_scope1':'DE Scope 1',
    't_scope2':'DE Scope 2',
    't_scope3':'DE Scope 3',
    't_net_change':'DE Net change',
    't_required_asset_ref': 'DE Asset Reference *',
    't_impact_type': 'DE Impact (Type) *',
    't_gresb_efficiency_measure': 'DE GRESB Efficiency Measure',
    't_required_status': 'DE Status *',
    't_action_plan_title': 'DE Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'DE Area Covered *',
    't_required_currency': 'DE Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'DE Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'DE Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'DE Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'DE Secondary Utility Type',
    't_secondary_utility_change': 'DE Secondary Utility Change',
    't_required_action_id': 'DE Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'DE Active / inactive',
    't_required_meter_pan': 'DE Meter name  / MPAN *',
    't_required_meter_id': 'DE Meter ID *',
    't_required_from_date': 'DE From date *',
    't_required_to_date': 'DE To date *',
    't_required_consumption': 'DE Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'DE Estimated/actual *',
    't_required_origin': 'DE Origin *',
    't_scheduled_date': 'DE Scheduled date',
    't_estimated_change': 'DE Estimated change',
    't_find_action': 'DE Find action',
    't_filters': 'DE Filters',
    't_btn_request_consumption': 'DE Request consumption',
    't_header_request_consumption': 'DE Request Consumption',
    't_additional_information': 'DE Additional Information',
    't_serial_number_consumption': 'DE Serial Number',
    't_utility_type_consumption': 'DE Utility Type',
    't_area_covered_consumption': 'DE Area Covered',
    't_meter_status': 'DE Meter Status',
    't_submeter': 'DE Submeter',
    't_all_categories': 'DE All categories',
    't_estimated_data': 'DE Estimated data',
    't_delete_record':'DE Delete record',
    't_delete_records':'DE Delete records',
    't_edit_record':'DE Edit record',
    't_edit_records':'DE Edit records',
    't_add_consumptions':'De Add consumption',
    't_asset_procurement_data_categories': 'DE <p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'DE Recipients (separate emails with commas)',
    't_request_email_placeholder': 'DE Add email recipients',
    't_request_send_button': 'DE Send request email',
    't_email_sent_confirmation': 'DE Email sent',
    't_select_utility': 'DE Select Utility',
    't_utilities': 'DE Utilities',
    't_clear_all':'DE Clear all',
    't_select_status':'DE Select status',
    't_select_impact':'DE Select impact',
    't_select_cost_type':'DE Select cost type',
    't_select_scope':'DE Select scope',
    't_select_procurement':'DE Select procurement',
    't_search_meter_placeholder': 'DE Search meter name...',
    't_no_meter_data_available': 'DE This meter has no data available within the specified time frame',
    't_select_all': 'DE Select All',
    't_error_title': 'DE Error',
    't_delete_warn':'DE Are you sure you want to delete this record?',
    't_delete_warn_s':'DE Are you sure you want to delete these records?',
    't_delete_yes':'DE Yes, delete',
    't_cancel_delete':'DE No, cancel',
    't_no_export_data_available_for_single_asset': 'DE The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'DE Origin',
    't_submitted_by': 'DE Submitted by',
    't_gap_filled_scope' : 'DE gap-filled',
    't_procured_data': 'DE procured data',
    't_meter_submitted_by': 'DE Submitted By',
    't_action_plan_improvement_sub_text': 'DE Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'DE Net Zero Carbon module not available.',
    't_action_details':'DE Action details',
    't_action_details_description':'DE Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_estimated_actual_required': 'DE Estimated or Actual *',
    't_action_information':'DE Action information',
    't_action_title': 'DE Action title',
    't_action_impact_error_message': 'DE Please select a impact',
    't_action_title_error_message': 'DE Please select a title',
    't_action_status_error_message': 'DE Please select a status',
    't_current_consumption_with_gapFilled': 'DE Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'DE Previous period consumption ({0})',
    't_consumption_information': 'DE Consumption Information',
    't_add_consumption_title': 'DE Add Consumption',
    't_edit_record_title': 'DE Edit Record',
    't_edit_records_title': 'DE Edit Records',
    't_update_record': 'DE Update Record',
    't_update_records': 'DE Update Records',
    't_update_record_confirmation': 'DE Record updated',
    't_update_records_confirmation': 'DE Records updated',
    't_submit_consumption': 'DE Submit consumption',
    't_submit_confirmation': 'DE Consumption added',
    't_associated_costs_utility': 'DE Associated costs and Utility',
    't_associated_costs_utility_desc': 'DE The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'DE Cost of action',
    't_select_currency': 'DE Select currency',
    't_action_currency_error_message': 'DE Please select a currency',
    't_action_title_error_msg': 'DE Please add a title',
    't_nodata_for_timeperiod': 'DE There is no data available for this time period',
    't_back_to_list': 'DE Back to List',
    't_add_data': 'DE Add Data',
    't_edit_data': 'DE Edit Data',
    't_select_area_covered':'DE Select area covered',
    't_action_area_covered_error_message':'DE Please select the area covered',
    't_gresb_efficiency_measure_select': 'DE Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'DE Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'DE Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'DE On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'DE Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'DE Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'DE Social media / Online platform',
    't_tenant_meetings_which_includes': 'DE Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'DE Tenant sustainability events',
    't_tenant_sustainability_guide': 'DE Tenant sustainability guide',
    't_tenant_sustainability_training': 'DE Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'DE Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split' : 'DE Gap-filled',
    't_action_scheduled_completion_date': 'DE Scheduled completion date',
    't_action_completion_date': 'DE Completion date',
    't_select_primary_utility': 'DE Select primary utility',
    't_select_secondary_utility': 'DE Select secondary utility',
    't_primary_utility': 'DE Primary utility',
    't_secondary_utility': 'DE Secondary utility',
    't_primary_utility_error_message': 'DE Please select a primary utility',
    't_primary_utility_cost_error_msg': 'DE Please enter a change',
    't_choose_breakdown': 'DE Choose breakdown',
    't_modified_date': 'DE Modified date',
    't_gap_filling' : 'DE Gap-filling',
    't_sold_badge_label': 'DE Sold in',
    't_view_detailed_dq_break_down':'DE View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'DE GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'DE Asset Name *',
    't_purchased': 'DE Purchased',
    't_nzc_sold': 'DE Sold',
    't_edit_asset': 'DE Edit asset',
    't_back_action_plan': 'DE Back to Action Plan',
    't_key_metrics': 'DE Key Metrics',
    't_payback_period': 'DE Payback period',
    't_matched_assets_count':'DE {0} assets selected, please match the remaining assets',
    't_search_by_asset':'DE Search by asset name',
    't_select_available_match':'DE Select from {0} available matches',
    't_fund_sfdr_pai_report':'DE SFDR PAI Report',
    't_y_o_y_trend': 'DE Year-on-Year Trend',
    't_adverse_sustainability_impact':'DE Adverse Sustainability Impact',
    't_tonnes_co2e':'DE tonnes CO2e',
    't_ghg_scope1': 'DE Scope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'DE Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'DE Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'DE Total GHG emissions generated by real estate assets',
    't_including_estimates': 'DE Including estimates',
    't_actual_only': 'DE Actual Only',
    't_percentage': 'Percentage',
    't_vertical': 'DE Vertical',
    't_horizontal': 'DE Horizontal',
    't_fossil_fuels': 'DE Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'DE GHG emissions by scope',
    't_gia_tooltip_content': 'DE This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'DE This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'DE This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'DE This is the area associated with external areas such as car parks.',
    't_effect_on_utilities':'DE Effect on utilities',
    't_single_year':'DE year',
    't_multiple_years':'DE years',
    't_gia_nla_required_message': 'DE Please ensure at least one field (GIA or NLA) is filled in',
    't_gia_nla_cpa_ext_length_validation_message': 'DE Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'DE Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'DE Please enter a date',
    't_future_year_error':'DE The year built can not be in the future',
    't_past_year_error' :'DE Year Built should be greater than 1800',
    't_invalid_year_error':'DE Invalid year format. Please enter a valid year',
    't_future_date_error': 'DE Date cannot be in the future',
    't_sale_date_error': 'DE Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'DE Please enter the purchase date',
    't_post_note': 'DE Post a note',
    't_clear_note': 'DE Clear note',
    't_higher_than_target': 'DE higher than target',
    't_lower_than_target': 'DE lower than target',
    't_higher_than_previous_period': 'DE higher than previous period',
    't_lower_than_previous_period': 'DE lower than previous period',
    't_date_created': 'DE Date created',
    't_created_by': 'DE Created by',
    't_gresb_sector_tooltip': 'DE Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'DE Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': 'DE {dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': 'DE {dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown': 'DE Please select an option from the dropdown',
    't_sync_success_message': 'DE Sync complete',
    't_notes_in_actions_not_saved' : 'DE Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'DE Select the country of the asset',
    't_select_the_region_of_asset': 'DE Select the region of the asset',
    't_enter_asset_name':'DE Please Enter Asset Name',
    't_validation_asset_name':'DE Asset name already exists. Choose a different name',
    't_validation_asset_reference':'DE Asset reference already exists. Choose a different reference',
    't_enter_asset_reference':'DE Please Enter Asset Reference',
    't_select_assetdetails_fund':'DE Select a fund',
    't_asset_ownership_invalid_input':'DE Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required':'DE Please enter a Fund Ownership %',
    't_asset_ownership_min_value':'DE Range should be between 1-100',
    't_asset_ownership_max_value':'DE Range should be between 1-100',
    't_documents': 'DE Documents',
    't_pai_selection': 'DE PAI selection',
    't_real_estate_mandatory': 'DE Mandatory for Real Estate',
    't_select_at_least': 'DE Select at least one from below',
    't_operational_control_asset': 'DE Select the Operational Control for the asset',
    't_select_at_least_one_option': 'DE Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'DE Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'DE Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'DE Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation':'DE Enter the date of this last evaluation',
    't_keyfacts': 'DE Key Facts',
    't_performance_overview': 'DE Performance overview',
    't_variance_against_target': 'DE Variance against target',
    't_variance_against_previous_period': 'DE Variance against previous period',
    't_below' : 'DE below',
    't_above' : 'DE above',
    't_gap_filled_data_not_applicable': 'DE gap-filled data not applicable',
    't_documents_n_certificates': 'DE Documents & Certificates',
    't_consumption_evidence': 'DE Consumption Evidence',
    't_filter_applied': 'DE {0} filter applied.',
    't_filters_applied': 'DE {0} filters applied.',
    't_download_documents': 'DE Download documents',
    't_top_down_pathways' : 'DE Top-Down pathways',
    't_upload_top_down_pathways' : 'DE Upload top-down pathways',
    't_pai_report': 'DE PAI Report',
    't_fossil_fuel_impact_report': 'DE Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'DE Energy Efficiency Impact Report',
    't_ghg_impact_report': 'DE GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'DE Energy Consumption Impact Report',
    't_waste_impact_report': 'DE Waste Management Impact Report',
    't_resource_consumption_impact_report': 'DE Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'DE Biodiversity Impact Report',
    't_quarterly_summary': 'DE Quarterly Summary',
    't_exposed_value': 'DE Exposed Value',
    't_total_applicable_value': 'DE Total Applicable Value',
    't_total_excluded_value': 'DE Total Excluded Value',
    't_share_applicable_value_exposed': 'DE Share of applicable value exposed',
    't_share_total_value_excluded': 'DE Share of total value excluded',
    't_principle_metrics': 'DE Principle Metrics',
    't_average_share_exposed_value': 'DE Average share of exposed value',
    't_average_share_total_value_excluded': 'DE Average share of total value excluded',
    't_ped_below_nzeb': 'DE PED below NZEB?',
    't_total_portfolio_value': 'DE Total Portfolio Value',
    't_construction_year': 'DE Construction Year',
    't_total_scope1_emissions': 'DE Total Scope 1 Emissions',
    't_total_scope2_emissions': 'DE Total Scope 2 Emissions',
    't_total_scope3_emissions': 'DE Total Scope 3 Emissions',
    't_total_ghg_emissions': 'DE Total GHG Emissions',
    't_actual_data_only': 'DE Actual data only',
    't_including_estimations': 'DE Including estimations',
    't_exposed_value_share': 'DE Share of exposed value',
    't_inefficient_re': 'DE Inefficient RE',
    't_overview': 'DE Overview',
    't_ghg': 'DE GHG',
    't_sustainable_tonnes': 'DE Sustainable tonnes',
    't_total_tonnes': 'DE Total tonnes',
    't_ghg_emissions': 'DE GHG Emissions',
    't_exposure_select': 'DE Select Exposure',
    't_total_contributing_area': 'DE Total contributing area',
    't_total_raw_material_usage': 'DE Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'DE Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'DE Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'DE Horizontal Artificialisation',
    't_vertical_artificialization': 'DE Vertical Artificialisation',
    't_coverage_by_floorArea': 'DE Coverage by floor area',
    't_filename': 'DE File Name',
    't_document_type': 'DE Document Type',
    't_implementation_date': 'DE Implementation Date',
    't_date_of_upload': 'DE Date of Upload',
    't_uploaded_by': 'DE Uploaded by',
    't_fundname': 'DE Fund Name',
    't_document_size': 'DE Document Size',
    't_export_documents': 'DE Export documents',
    't_validation_errors':'DE Record has validation errors',
    't_validation_warning':'DE Record has warnings',
    't_validation_consumption_blank':'DE Please enter consumption for this date range.',
    't_validation_consumption_specific':'DE Please specify whether this consumption is estimated or actual.',
    't_validation_source':'DE Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank':'DE Please enter from date.',
    't_validation_to_date_blank':'DE Please enter to date.',
    't_validation_comment':'DE This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed':'DE SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive':'DE You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period':'DE This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period':'DE The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today':'DE As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser':'DE From date should be less than or equal to To date.',
    't_validation_date_overlap':'DE We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'DE Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'DE You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'DE Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'DE Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'DE Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'DE When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'DE Actions breakdown',
    't_filenames': 'DE File Name(s)',
    't_metername': 'DE Meter Name',
    't_select_the_status_of_asset':'DE Please select a status for this asset.',
    't_to_tc': 'DE To',
    't_delete_document': 'DE Delete document',
    't_confirm_delete_document': 'DE Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'DE Are you sure you want to delete these documents?',
    't_top_down_carbon_intensity' : 'DE Top-Down Carbon intensity',
    't_top_down_energy_intensity' : 'DE Top-Down Energy intensity',
    't_top_down_pathways_template_filename' : 'DE Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title' : 'DE Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title' : 'DE Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template' : 'DE How to use this template',
    't_pathway_name':'DE Pathway Name',
    't_pathway':'DE Pathway',
    't_top_down_template_instruction_1' : 'DE This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2' : 'DE This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3' : 'DE You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4' : 'DE The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5' : 'DE You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6' : 'DE You must enter numerical values in these cells.',
    't_top_down_template_instruction_7' : 'DE Please make sure you know the units you are using from Siera.',
    't_previous_period_recycled': 'DE previous period (recycled)',
    't_total_missing_data': 'DE total missing data',
    't_filter_documents': 'DE Filter documents',
    't_filter_consumption_evidence': 'DE Filter consumption evidence',
    't_valid_within': 'DE Valid within',
    't_evidence_date_range': 'DE Evidence date range',
    't_pick_date_range': 'DE Pick a date range',
    't_pick_evidence_date_range': 'DE Pick evidence date range',
    't_doc_type': 'DE Document type',
    't_select_doc_type': 'DE Select document type',
    't_select_doc_fund': 'DE Select fund',
    't_select_asset': 'DE Select asset',
    't_select_doc_country': 'DE Select country',
    't_select_managing_agent': 'DE Select managing agent',
    't_select_user': 'DE Select user',
    't_search_fund': 'DE Search by fund name',
    't_search_asset': 'DE Search by asset name or asset ref',
    't_search_name': 'DE Search by name',
    't_search_document': 'DE Search by document name',
    't_search_country': 'DE Search by country name',
    't_select_meter': 'DE Select meter',
    't_search_meter': 'DE Search meter',
    't_search_sector': 'DE Search sector',
    't_assurance_doc': 'DE Assurance document',
    't_audit_report': 'DE Audit/Recommendations report',
    't_energy_rating_certificate': 'DE Energy rating certificate',
    't_fund_report': 'DE Fund reports',
    't_green_building_certificate': 'DE Green building certificate',
    't_sustainability_action_plan': 'DE Sustainability action plan',
    't_sustainable_weight_greater_than_total_weight': 'DE Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'DE Start date must be before end date',
    't_select_a_status': 'DE Select a status',
    't_remove_item': 'DE Remove item',
    't_add_new_record': 'DE Add new record',
    't_add_old_record': 'DE Add old record',
    't_select_date_error': 'DE Please select a date',
    't_date_set_automatically': 'DE This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'DE Present',
    't_exposed': 'DE Exposed',
    't_not_exposed': 'DE Not exposed',
    't_renewable_energy_certificate':'DE Renewable energy certificate',
    't_expiry_date':'DE Expiry date',
    't_select_expiry_date':'DE Select expiry date',
    't_report_date':'DE Report date *',
    't_select_report_date':'DE Select a valid report date',
    't_record_type_document':'DE Which record type does this document belong to? *',
    't_select_record_type':'DE Select record type',
    't_select_document_type':'DE Select document type',
    't_drag_drop':'DE Drag and drop or',
    't_document_select_file':'DE Select file',
    't_document_export':'DE Document Export',
    't_add_document':'DE Add document',
    't_search_fund_ref':'DE Search by fund name',
    't_delete_top_down_pathway': 'DE Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'DE Are you sure you want to delete this top-down pathway?',
    't_exposure':'DE Exposure',
    't_contract_status': 'DE Contract status',
    't_active': 'DE Active',
    't_inactive': 'DE Inactive',
    't_saved':'DE Saved',
    't_document_upload':'DE Document upload *',
    't_asset_reference_address': 'DE Asset Reference & Address',
    't_clear_filters':'DE Clear filters',
    't_variance_previous_period_or_target':'DE Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'DE Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'DE GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'DE Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'DE Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': 'DE {fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': 'DE {areas} cannot be empty.',
    't_top_down_pathway_success_message_one' : 'DE {0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : 'DE {0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'DE Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'DE Return to Net Zero Carbon',
    't_save_document':'DE Save document',
    't_save_documents':'DE Save documents',
    't_edit_document':'DE Edit document',
    't_add_another_document':'DE Add another document',
    't_variance_explanation_title': 'DE Variance explanation',
    't_variance_explanation': 'DE Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'DE New document',
    't_update_document':'DE Update document',
    't_update_documents':'DE Update documents',
    't_document_updated':'DE Updated',
    't_target_variance': 'DE Target variance',
    't_period_variance': 'DE Period variance',
    't_landlord_data':'DE Landlord Data',
    't_tenant_procurement':'DE Tenant Procurement',
    't_planning_permission_before_year_built':'DE Planning Permission Date must be before the Year built.',
    't_impact_info': 'DE What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'DE Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'DE Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'DE Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'DE Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'DE The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'DE Utility consumption per year',
    't_utility_cost_year': 'DE Utility cost per year',
    't_utility_consumption_year_info': 'DE <info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': 'DE <info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'DE Tenant controlled',
    't_landlord_controlled': 'DE Landlord controlled',
    't_cannot_be_empty':'DE This field cannot be empty',
    't_add_asset_success': 'DE Asset has been created',
    't_add_asset_summary': 'DE Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'DE Asset has been updated',
    't_edit_asset_summary': 'DE Updates across all modules will be reflected shortly.',
    't_select_framework': 'DE Select a framework',
    't_utility_per_year': 'DE Utility per year',
    't_cost_per_year': 'DE Cost per year',
    't_utility_per_year_info_content_one': 'DE 1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': 'DE -1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': 'DE {0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': 'DE -{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'DE Year {year}',
    't_ped_tooltip_content': 'DE An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'DE The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'DE Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'DE The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'DE The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'DE The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'DE The total external, vertical surface area of the asset.',
    't_click_to_read': 'DE Click here to read more',
    't_reporting_years': 'DE Reporting Years',
    't_data_readiness': 'DE Data Readiness',
    't_waste_contract_status': 'DE Waste Contract Status',
    't_evaluation_date': 'DE Evaluation Date',
    't_add_new_status': 'DE Add new status',
    't_add_historic_status': 'DE Add historic status',
    't_add_new_exposure': 'DE Add new exposure',
    't_add_historic_exposure': 'DE Add historic exposure',
    't_siera_version': 'DE SIERA version',
    't_renewables': 'DE Renewables',
    't_on_site_generation': 'DE On-site generation',
    't_gia_percentage': 'DE {0}% of your GIA {1}',
    't_assets_count': 'DE {0} assets',
    't_self_consumption': 'DE {0}% Self consumption',
    't_export_to_grid': 'DE {0}% Exported to grid',
    't_contribution_electricity_consumption': 'DE {0}% Contribution to electricity consumption',
    't_on_site_generated': 'DE {0}% On site generated',
    't_off_site_purchased': 'DE {0}% Off-site purchased',
    't_non_renewables': 'DE {0}% Non-renewables',
    't_renewables_floor_area': 'DE Renewables floor area',
    't_renewables_floor_area_info': 'DE This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'DE Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'DE Which asset does this document belong to? *',
    't_valid_from_document':'DE Valid from date *',
    't_expiry_date_mandatory':'DE Expiry date *',
    't_end_date_after_start_date': 'DE End date must be after start date',
    't_action_deleted': 'DE Action successfully deleted',
    't_action_deleted_content': 'DE ‘{0}’ action has been deleted by {1}',
    't_select_agent': 'DE Select Agent',
    't_supplier_estimate': 'DE Supplier estimate',
    't_calculated_estimate': 'DE Calculated estimate',
    't_dq_total_asset_floor_area': 'DE Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'DE Floor area unaccounted for',
    't_action_name_exists': 'DE Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'DE Managing Agent',
    't_data_coverage' : 'DE Data coverage',
    't_data_completeness': 'DE Data completeness',
    't_fund_data_coverage': '<p><b>DE Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>DE Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'DE Add new Evaluation',
    't_add_new_occupancy': 'DE Add new Occupancy',
    't_documents_space_exceed':'DE You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'DE Data Category',
    't_supplier': 'DE Supplier',
    't_area_served': 'DE Floor Area Served',
    't_add_consumption': 'DE Add consumption',
    't_all_data_categories': 'DE All data categories',
    't_agreed_actions_count_nzc':'DE {0} Agreed actions',
    't_applicable_actions_count_nzc':'DE {0} Applicable actions',
    't_stranding_year_year': 'DE {0} (CRREM Misalignment year)',
    't_not_stranding': 'DE Not CRREM Misaligned',
    't_actions_pathway_recommended': 'DE Actions pathway (recommended)',
    't_actions_pathway_optional': 'DE Actions pathway (optional)',
    't_agreed_actions_pathway': 'DE Agreed actions pathway',
    't_applicable_actions_pathway': 'DE Applicable actions pathway',
    't_bau_pathway': 'DE Business as usual pathway',
    't_fund_view': 'DE Fund view',
    't_assets_list': 'DE Assets list',
    't_chart_specification': 'DE Chart specification',
    't_chart_preconfigured': 'DE This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- DE Grid decarbonisation',
    't_sbt_toast': '- DE Science based target (1.5C)',
    't_bau_toast': '- DE Business as Usual',
    't_agreed_actions_toast': '- DE Agreed Action based pathways',
    't_reporting_year_value': 'DE Reporting year: {0}',
    't_cost_intensity_value': 'DE {0} GBP/m²/yr',
    't_energy_intensity_value': 'DE {0} kWh/m²/yr',
    't_carbon_intensity_value': 'DE {0} kg CO₂e/m²/yr',
    't_co2_emissions_value': 'DE {0} kg CO₂e/yr',
    't_data_coverage_percentage_value' : 'DE {0}% Data coverage',
    't_origin_meter_reading': 'DE Meter reading',
    't_origin_invoice': 'DE Invoice',
    't_origin_amr': 'DE AMR',
    't_actual_data': 'DE Actual data',
    'jv_between_funds': 'DE Joint venture between funds:',
    't_meter_inactive_sold': 'DE Meter was inactive or asset was not owned during this month',
    't_coverage': 'DE Coverage',
    't_completeness': 'DE Completeness',
    't_total_asset_floor_gia': 'DE Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'DE Expiry date must be after report date',
    't_unique_file_name': 'DE A file with this name already exists',
    't_special_character': 'DE File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'DE Comment can\'t contain special characters',
    't_custom': 'DE Custom'
  }
}
